// AUTO-GENERATED by scripts/generate-endpoints.ts. Do not edit.

export const ENDPOINTS = {
  AcceptInvitation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/invitations/{invitation}:accept',
  },
  AcceptWorkUnitInput: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workUnits/{workUnit}:acceptInput',
  },
  AccessSecretVersion: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/secrets/{id}/versions/{version}:access',
  },
  AccessSecretVersion2: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/secrets/{id}/versions/{version}:access',
  },
  ActivateAutomation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:activate',
  },
  ActivatePlan: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan:activate',
  },
  ActivateSchedule: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/schedules/{id}:activate',
  },
  ActivateTrigger: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/triggers/{trigger_id}:activate',
  },
  AddAgentPlanPhase: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan/phases',
  },
  AddAgentPlanStep: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps',
  },
  AddAutomationConnections: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:addConnections',
  },
  AddCollectionField: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}:addField',
  },
  AddRoleTemplatePermissions: {
    method: 'POST',
    path: '/agora.v1.RBACService/AddRoleTemplatePermissions',
  },
  AddSecretVersion: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/secrets/{id}:addVersion',
  },
  AddSecretVersion2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/secrets/{id}:addVersion',
  },
  AddTestCase: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evals/{evalId}/testCases',
  },
  AddThreadMessage: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent}/threads/{thread}:addMessage',
  },
  AddToolAdapter: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  AddWorkspaceBookConnection: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books/{book_name}/{book_version}/connections',
  },
  AddWorkspaceBookConnectionAgentTriggerInstance: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books/{book_name}/{book_version}/connections/{connection_id}/agent-triggers',
  },
  AddWorkspaceBookConnectionPollInstance: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books/{book_name}/{book_version}/connections/{connection_id}/polls',
  },
  AddWorkspaceBookConnectionTriggerInstance: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books/{book_name}/{book_version}/connections/{connection_id}/triggers',
  },
  AddWorkspaceBookConnectionWithRemoteSecret: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books/{book_name}/{book_version}/connections/with-remote-secret',
  },
  AdoptSecret: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/secrets:adopt',
  },
  AdoptSecret2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/secrets:adopt',
  },
  AggregateNeighbors: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}:aggregateNeighbors',
  },
  ApplyCommand: {
    method: 'POST',
    path: '/v1/organizations/{organization}/workspaces/{workspace}/cartographer:apply',
  },
  ApplyCommand2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/cartographer:apply',
  },
  ApproveAccessRequest: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/invitations/{invitation}:approveAccess',
  },
  ApproveEvalRunResults: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evalRuns/{evalRun}:approveEvalRunResults',
  },
  ArchiveExceptions: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptions:archive',
  },
  ArchiveRuns: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs:archive',
  },
  ArchiveThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent}/threads/{thread}:archive',
  },
  ArchiveWorkItem: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workItems/{workItem}:archive',
  },
  AssignExceptions: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptions:assign',
  },
  AssignOrganizationUserRoles: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/users/{user}:assignRoles',
  },
  AssignWorkItem: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workItems/{workItem}:assign',
  },
  AssignWorkspaceUserRoles: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/users/{user}:assignRoles',
  },
  AssociateRemoteConnection: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}/remote-connection',
  },
  AssumeSupportRole: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/supportAccessGrants/{supportAccessGrant}:assume',
  },
  AssumeSupportRole2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/supportAccessGrants/{supportAccessGrant}:assume',
  },
  AuthorizeWorkspaceBookConnection: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}/authorize',
  },
  AutomationActivatePlan: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan:activate',
  },
  AutomationActivateSchedule: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/schedules/{id}:activate',
  },
  AutomationAddAgentPlanPhase: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan/phases',
  },
  AutomationAddAgentPlanStep: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps',
  },
  AutomationAddToolAdapter: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  AutomationClearCompactor: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/compactor',
  },
  AutomationClearEmbedder: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/embedder',
  },
  AutomationClearFollowUpGenerator: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/follow-up',
  },
  AutomationClearGenerator: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/generator',
  },
  AutomationClearThreadMemory: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/memory/{block_id}',
  },
  AutomationClearUtilityGenerator: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/utility-generator',
  },
  AutomationCommitArtifacts: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifacts:commit',
  },
  AutomationCountTokens: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/generator/tokenize:count',
  },
  AutomationCreateAgent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents',
  },
  AutomationCreateAgentPlan: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan',
  },
  AutomationCreateArtifactStore: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifact-stores',
  },
  AutomationCreateArtifactType: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifact-types',
  },
  AutomationCreateCredential: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/credentials',
  },
  AutomationCreateMemoryBlock: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/memory-blocks',
  },
  AutomationCreateSchedule: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/schedules',
  },
  AutomationCreateSubAgent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/sub-agents',
  },
  AutomationCreateThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads',
  },
  AutomationCreateToolSource: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tool-sources',
  },
  AutomationCreateVariable: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/variables',
  },
  AutomationCreateVectorCollection: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections',
  },
  AutomationCreateVectorStore: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/vector-stores',
  },
  AutomationDeactivatePlan: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan/active:deactivate',
  },
  AutomationDeactivateSchedule: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/schedules/{id}:deactivate',
  },
  AutomationDehydrateThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}:dehydrate',
  },
  AutomationDeleteAgent: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}',
  },
  AutomationDeleteAgentPlan: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan',
  },
  AutomationDeleteAllThreads: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads',
  },
  AutomationDeleteArtifact: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}',
  },
  AutomationDeleteArtifactStore: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifact-stores/{store_id}',
  },
  AutomationDeleteArtifactType: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifact-types/{type_id}',
  },
  AutomationDeleteCredential: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/credentials/{credential_id}',
  },
  AutomationDeleteEvent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/events:delete',
  },
  AutomationDeleteMemoryBlock: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}',
  },
  AutomationDeleteSavedFilter: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/saved-filters/{surface}/{id}',
  },
  AutomationDeleteSchedule: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/schedules/{id}',
  },
  AutomationDeleteSubAgent: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/sub-agents/{sub_agent_id}',
  },
  AutomationDeleteThread: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}',
  },
  AutomationDeleteToolSource: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tool-sources/{source_id}',
  },
  AutomationDeleteVariable: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/variables/{variable_name}',
  },
  AutomationDeleteVectorCollection: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections/{collection}',
  },
  AutomationDeleteVectorStore: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}',
  },
  AutomationDeploy: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/agent:deploy',
  },
  AutomationDescribeVectorCollection: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections/{collection}',
  },
  AutomationDiffAgentPlan: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan:diff',
  },
  AutomationDiffArtifacts: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifacts:diff',
  },
  AutomationDiffArtifactStores: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifact-stores:diff',
  },
  AutomationDiffArtifactTypes: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifact-types:diff',
  },
  AutomationDiffCompactor: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/compactor:diff',
  },
  AutomationDiffEmbedder: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/embedder:diff',
  },
  AutomationDiffFollowUpGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/follow-up:diff',
  },
  AutomationDiffGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/generator:diff',
  },
  AutomationDiffMemoryBlocks: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/memory-blocks:diff',
  },
  AutomationDiffSubAgents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/sub-agents:diff',
  },
  AutomationDiffTools: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools:diff',
  },
  AutomationDiffToolSources: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tool-sources:diff',
  },
  AutomationDiffUtilityGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/utility-generator:diff',
  },
  AutomationDiffVariables: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/variables:diff',
  },
  AutomationDiffVectorStores: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/vector-stores:diff',
  },
  AutomationDisableTool: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}:disable',
  },
  AutomationDisableTools: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}:disable',
  },
  AutomationDiscardArtifacts: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifacts:discard',
  },
  AutomationDuplicateAgent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}:duplicate',
  },
  AutomationEmbedAudio: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/embedder:embed-audio',
  },
  AutomationEmbedAudioBatch: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/embedder:embed-audio-batch',
  },
  AutomationEmbedImage: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/embedder:embed-image',
  },
  AutomationEmbedImageBatch: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/embedder:embed-image-batch',
  },
  AutomationEmbedText: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/embedder:embed-text',
  },
  AutomationEmbedTextBatch: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/embedder:embed-text-batch',
  },
  AutomationEmbedVideo: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/embedder:embed-video',
  },
  AutomationEmbedVideoBatch: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/embedder:embed-video-batch',
  },
  AutomationEnableTool: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}:enable',
  },
  AutomationEnableTools: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}:enable',
  },
  AutomationExportAgent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}:export',
  },
  AutomationForkThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}:fork',
  },
  AutomationGenerate: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/rain.v1.GeneratorService/Generate',
  },
  AutomationGetActivePlan: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan/active',
  },
  AutomationGetAgent: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}',
  },
  AutomationGetAgentPlan: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan',
  },
  AutomationGetAgentVersion: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/versions/{version}',
  },
  AutomationGetAgentVersionByTag: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/tags/{tag}',
  },
  AutomationGetArtifact: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}',
  },
  AutomationGetArtifactContent: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}:content',
  },
  AutomationGetArtifactDiff: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}:diff',
  },
  AutomationGetArtifactsStagingSummary: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifacts:staging',
  },
  AutomationGetCompactor: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/compactor',
  },
  AutomationGetCredential: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/credentials/{credential_id}',
  },
  AutomationGetDynamicArtifactStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/artifact-stores:dynamic-config',
  },
  AutomationGetDynamicArtifactTypeConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/artifact-types:dynamic-config',
  },
  AutomationGetDynamicCompactorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/compactor:dynamic-config',
  },
  AutomationGetDynamicCredentialConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/credentials:dynamic-config',
  },
  AutomationGetDynamicEmbedderConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/embedder:dynamic-config',
  },
  AutomationGetDynamicExportFormatConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/export-formats:dynamic-config',
  },
  AutomationGetDynamicFollowUpGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/follow-up:dynamic-config',
  },
  AutomationGetDynamicGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/generator:dynamic-config',
  },
  AutomationGetDynamicImportFormatConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/import-formats:dynamic-config',
  },
  AutomationGetDynamicMemoryBlockConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/memory-blocks:dynamic-config',
  },
  AutomationGetDynamicSubAgentConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/sub-agents:dynamic-config',
  },
  AutomationGetDynamicToolAdapterConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/tool-adapters:dynamic-config',
  },
  AutomationGetDynamicToolSourceConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/tool-sources:dynamic-config',
  },
  AutomationGetDynamicUtilityGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/utility-generator:dynamic-config',
  },
  AutomationGetDynamicVectorStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/vector-stores:dynamic-config',
  },
  AutomationGetEmbedder: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/embedder',
  },
  AutomationGetEmbedderInfo: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/embedder-info',
  },
  AutomationGetEvents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/events',
  },
  'rain-v1-automation_scoped-agent_service.AutomationGetFilterSchema': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents:filter-schema',
  },
  'rain-v1-automation_scoped-credential_service.AutomationGetFilterSchema': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/credentials:filter-schema',
  },
  'rain-v1-automation_scoped-schedule_service.AutomationGetFilterSchema': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/schedules:filter-schema',
  },
  'rain-v1-automation_scoped-thread_service.AutomationGetFilterSchema': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/threads:filter-schema',
  },
  AutomationGetFollowUpGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/follow-up',
  },
  AutomationGetGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/generator',
  },
  AutomationGetMemoryBlock: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}',
  },
  AutomationGetModelInfo: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/generator:model-info',
  },
  AutomationGetQueue: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/queue',
  },
  AutomationGetSchedule: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/schedules/{id}',
  },
  AutomationGetServiceInfo: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/info',
  },
  AutomationGetStaticArtifactStoreConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/artifact-stores:static-config',
  },
  AutomationGetStaticArtifactTypeConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/artifact-types:static-config',
  },
  AutomationGetStaticCompactorConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/compactor:static-config',
  },
  AutomationGetStaticCredentialConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/credentials:static-config',
  },
  AutomationGetStaticEmbedderConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/embedder:static-config',
  },
  AutomationGetStaticExportFormatConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/export-formats:static-config',
  },
  AutomationGetStaticFollowUpGeneratorConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/follow-up:static-config',
  },
  AutomationGetStaticGeneratorConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/generator:static-config',
  },
  AutomationGetStaticImportFormatConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/import-formats:static-config',
  },
  AutomationGetStaticMemoryBlockConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/memory-blocks:static-config',
  },
  AutomationGetStaticSubAgentConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/sub-agents:static-config',
  },
  AutomationGetStaticToolAdapterConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/tool-adapters:static-config',
  },
  AutomationGetStaticToolSourceConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/tool-sources:static-config',
  },
  AutomationGetStaticUtilityGeneratorConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/utility-generator:static-config',
  },
  AutomationGetStaticVectorStoreConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/vector-stores:static-config',
  },
  AutomationGetThread: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}',
  },
  AutomationGetThreadAgentCard: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/card',
  },
  AutomationGetThreadContext: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/context',
  },
  AutomationGetThreadCostSummary: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/cost',
  },
  AutomationGetThreadCustomizations: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/customizations',
  },
  AutomationGetThreadMemory: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/memory',
  },
  AutomationGetThreadMemoryBlock: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/memory/{block_id}',
  },
  AutomationGetTool: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{tool_id}',
  },
  AutomationGetToolAdapter: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters/{adapter_id}',
  },
  AutomationGetToolAdapterChain: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters:chain',
  },
  AutomationGetUtilityGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/utility-generator',
  },
  AutomationGetUtilityGeneratorModelInfo: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/utility-generator:model-info',
  },
  AutomationGrepArtifacts: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifacts:grep',
  },
  AutomationImportAgent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents:import',
  },
  AutomationInvokeTool: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools:invoke',
  },
  AutomationListAgentLabels: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents:labels',
  },
  AutomationListAgents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents',
  },
  AutomationListAgentVersions: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/versions',
  },
  AutomationListAllSchedules: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/schedules',
  },
  AutomationListAllThreads: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/threads',
  },
  AutomationListArtifacts: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifacts',
  },
  AutomationListArtifactStoreDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/artifact-stores:dynamic-enum-values',
  },
  AutomationListArtifactStoreKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/artifact-stores/kinds',
  },
  AutomationListArtifactStores: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifact-stores',
  },
  AutomationListArtifactTypeDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/artifact-types:dynamic-enum-values',
  },
  AutomationListArtifactTypeKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/artifact-types/kinds',
  },
  AutomationListArtifactTypes: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifact-types',
  },
  AutomationListCompactorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/compactors:dynamic-enum-values',
  },
  AutomationListCompactorKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/compactors/kinds',
  },
  AutomationListCredentialDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/credentials:dynamic-enum-values',
  },
  AutomationListCredentialKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/credentials/kinds',
  },
  AutomationListCredentials: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/credentials',
  },
  AutomationListCredentialStoreKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/credential-stores/kinds',
  },
  AutomationListEmbedderDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/embedders:dynamic-enum-values',
  },
  AutomationListEmbedderKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/embedders/kinds',
  },
  AutomationListExportFormatKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/export-formats/kinds',
  },
  AutomationListFollowUpGeneratorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/follow-ups:dynamic-enum-values',
  },
  AutomationListFollowUpGeneratorKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/follow-ups/kinds',
  },
  AutomationListGeneratorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/generators:dynamic-enum-values',
  },
  AutomationListGeneratorKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/generators/kinds',
  },
  AutomationListImportFormatKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/import-formats/kinds',
  },
  AutomationListMemoryBlockDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/memory-blocks:dynamic-enum-values',
  },
  AutomationListMemoryBlockKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/memory-blocks/kinds',
  },
  AutomationListMemoryBlocks: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/memory-blocks',
  },
  AutomationListSavedFilters: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/saved-filters/{surface}',
  },
  AutomationListSchedules: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/schedules',
  },
  AutomationListSubAgentKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/sub-agents/kinds',
  },
  AutomationListSubAgents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/sub-agents',
  },
  AutomationListThreads: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads',
  },
  AutomationListToolAdapterDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/tool-adapters:dynamic-enum-values',
  },
  AutomationListToolAdapterKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/tool-adapters/kinds',
  },
  AutomationListToolAdapters: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  'rain-v1-automation_scoped-thread_service.AutomationListTools': {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/rain.v1.ThreadService/ListTools',
  },
  'rain-v1-automation_scoped-tool_catalog_service.AutomationListTools': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools',
  },
  AutomationListToolSourceDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/tool-sources:dynamic-enum-values',
  },
  AutomationListToolSourceKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/tool-sources/kinds',
  },
  AutomationListToolSources: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tool-sources',
  },
  AutomationListUtilityGeneratorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/utility-generators:dynamic-enum-values',
  },
  AutomationListVariables: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/variables',
  },
  AutomationListVectorCollections: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections',
  },
  AutomationListVectorStoreDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/vector-stores:dynamic-enum-values',
  },
  AutomationListVectorStoreKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/vector-stores/kinds',
  },
  AutomationListVectorStores: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/vector-stores',
  },
  AutomationMarkStep: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan/active/phases/{phase_index}/steps/{step_index}:mark',
  },
  AutomationPreviewToolAdapterChain: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters:preview',
  },
  AutomationPromoteActivePlan: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan:promote',
  },
  AutomationRehydrateThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}:rehydrate',
  },
  AutomationRemoveAgentPlanPhase: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}',
  },
  AutomationRemoveAgentPlanStep: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps/{step_index}',
  },
  AutomationRemoveAllToolAdapters: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  AutomationRemoveToolAdapter: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters/{adapter_id}',
  },
  AutomationReorderAgentPlanPhases: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan/phases:reorder',
  },
  AutomationReorderAgentPlanSteps: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps:reorder',
  },
  AutomationReorderToolAdapters: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  AutomationReplaceMemoryContent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}:replace',
  },
  AutomationResetConfig: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/agent:reset',
  },
  AutomationResetEvents: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/events:reset',
  },
  AutomationResetPlan: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan/active:reset',
  },
  AutomationRestoreAgentVersion: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/versions/{version}:restore',
  },
  AutomationRestoreEvent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/events:restore',
  },
  AutomationRunScheduleNow: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/schedules/{id}:run',
  },
  AutomationSaveFilter: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/saved-filters/{surface}',
  },
  AutomationSendMessage: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/input',
  },
  AutomationSendMessageSync: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/events',
  },
  AutomationSendToolCall: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tool-calls',
  },
  AutomationSendToolResult: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tool-results',
  },
  AutomationSetCompactor: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/compactor',
  },
  AutomationSetEmbedder: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/embedder',
  },
  AutomationSetEnabledTools: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}:set',
  },
  AutomationSetFeedback: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/feedback',
  },
  AutomationSetFollowUpGenerator: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/follow-up',
  },
  AutomationSetGenerator: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/generator',
  },
  AutomationSetToolAdapters: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters:set',
  },
  AutomationSetUtilityGenerator: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/utility-generator',
  },
  AutomationStartCompaction: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}:compact',
  },
  AutomationStop: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}:stop',
  },
  AutomationSubscribeAgentThreadStatus: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/rain.v1.ThreadService/SubscribeAgentThreadStatus',
  },
  AutomationSubscribeThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/rain.v1.ThreadService/SubscribeThread',
  },
  AutomationSubscribeThreadStatus: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/rain.v1.ThreadService/SubscribeThreadStatus',
  },
  AutomationTagAgentVersion: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/versions/{version}:tag',
  },
  AutomationTokenize: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/generator/tokenize',
  },
  AutomationTransfer: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}:transfer',
  },
  AutomationUntagAgentVersion: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/tags/{tag}',
  },
  AutomationUpdateAgent: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}',
  },
  AutomationUpdateAgentPlanPhase: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}',
  },
  AutomationUpdateAgentPlanStep: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps/{step_index}',
  },
  AutomationUpdateArtifact: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}',
  },
  AutomationUpdateArtifactStore: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifact-stores/{store_id}',
  },
  AutomationUpdateArtifactType: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/artifact-types/{type_id}',
  },
  AutomationUpdateCredential: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/credentials/{credential_id}',
  },
  AutomationUpdateMemoryBlock: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}',
  },
  AutomationUpdateSchedule: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/schedules/{id}',
  },
  AutomationUpdateSubAgent: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/sub-agents/{sub_agent_id}',
  },
  AutomationUpdateThread: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}',
  },
  AutomationUpdateThreadAgentCard: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/card',
  },
  AutomationUpdateThreadMemory: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/memory/{block_id}',
  },
  AutomationUpdateTool: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}',
  },
  AutomationUpdateToolAdapter: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters/{adapter_id}',
  },
  AutomationUpdateToolSource: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/tool-sources/{source_id}',
  },
  AutomationUpdateVariable: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/variables/{variable_name}',
  },
  AutomationUpdateVectorStore: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}',
  },
  AutomationUpgradeAllThreads: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads:upgradeAll',
  },
  AutomationUpgradeThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/agent:upgrade',
  },
  AutomationUploads_StageFile: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}/uploads',
  },
  AutomationValidateArtifactStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/artifact-stores:validate',
  },
  AutomationValidateArtifactTypeConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/artifact-types:validate',
  },
  AutomationValidateCompactorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/compactor:validate',
  },
  AutomationValidateCredentialConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/credentials:validate',
  },
  AutomationValidateEmbedderConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/embedder:validate',
  },
  AutomationValidateFollowUpGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/follow-up:validate',
  },
  AutomationValidateGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/generator:validate',
  },
  AutomationValidateMemoryBlockConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/memory-blocks:validate',
  },
  AutomationValidateToolAdapterConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/tool-adapters:validate',
  },
  AutomationValidateToolSourceConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/tool-sources:validate',
  },
  AutomationValidateUtilityGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/utility-generator:validate',
  },
  AutomationValidateVectorStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/vector-stores:validate',
  },
  AutomationWake: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent_id}/threads/{thread_id}:wake',
  },
  BackfillPermissionsForRoleTemplate: {
    method: 'POST',
    path: '/agora.v1.RBACService/BackfillPermissionsForRoleTemplate',
  },
  BatchCreateSubmissions: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workUnits/submissions:batchCreate',
  },
  BatchDeleteAssets: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/assets:batchDelete',
  },
  BatchDeleteCollectionRows: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}/rows:batchDelete',
  },
  BatchDeleteFolders: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/folders:batchDelete',
  },
  BatchDownloadAssets: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/assets:batchDownload',
  },
  BatchDownloadFolders: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/folders:batchDownload',
  },
  BatchDuplicateAssets: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/assets:batchDuplicate',
  },
  BatchDuplicateFolders: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/folders:batchDuplicate',
  },
  BatchGetAutomationNames: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations:batchGetNames',
  },
  BatchGetRunExecutionTimes: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/runs/executionTimes:batchGet',
  },
  BatchGetUserAuthorizationVersions: {
    method: 'POST',
    path: '/agora.v1.RBACService/BatchGetUserAuthorizationVersions',
  },
  BatchInsertCollectionRows: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}/rows:batchInsert',
  },
  BatchMoveAssets: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/assets:batchMove',
  },
  BatchMoveFolders: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/folders:batchMove',
  },
  BatchTraceCollectionUsage: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections:batchTraceCollectionUsage',
  },
  BatchUpdateCollectionRows: {
    method: 'POST',
    path: '/bishop.collections.v1.CollectionRowsService/BatchUpdateCollectionRows',
  },
  BatchUpdateGuides: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/guides:batchUpdate',
  },
  BuildStepHarness: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/stepHarness',
  },
  BulkUpgradeAutomationBookConnections: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations:bulkUpgradeBookConnections',
  },
  CancelDetectorRun: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/detectorRuns/{detectorRun}:cancel',
  },
  CancelGeneration: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent}/events:cancelGeneration',
  },
  CancelSync: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/connectors/{connector}/syncJobs/{syncJob}:cancel',
  },
  CancelThreadMessage: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent}/threads/{thread}/messages/{message}:cancel',
  },
  Check: {
    method: 'POST',
    path: '/astral.v1.Health/Check',
  },
  CheckRunMetric: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/runMetrics:check',
  },
  CheckUserSupportRole: {
    method: 'POST',
    path: '/agora.v1.SupportService/CheckUserSupportRole',
  },
  ClassifyException: {
    method: 'POST',
    path: '/astral.v1.ExceptionManagerService/ClassifyException',
  },
  ClearCompactor: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/compactor',
  },
  ClearEmbedder: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/embedder',
  },
  ClearFollowUpGenerator: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/follow-up',
  },
  ClearGenerator: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/generator',
  },
  ClearThreadMemory: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/memory/{block_id}',
  },
  ClearUtilityGenerator: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/utility-generator',
  },
  CommitArtifacts: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifacts:commit',
  },
  CompareValues: {
    method: 'POST',
    path: '/jarvis.v1.JarvisService/CompareValues',
  },
  ComputePatchedCode: {
    method: 'POST',
    path: '/jarvis.v1.JarvisService/ComputePatchedCode',
  },
  ConfigureAutomationEstimates: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/dashboards:configureAutomationEstimates',
  },
  ConfigureCurrentUserWorkspaceNotificationChannelStatus: {
    method: 'POST',
    path: '/api/v1/me/organizations/{organization}/workspaces/{workspace}/notificationChannels/{channel}:configureStatus',
  },
  ConfigureWorkspaceDetectors: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workspaceDetectorConfigs:configure',
  },
  ConfigureWorkspaceNotificationChannelStatus: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/notificationChannels/{channel}:configureStatus',
  },
  ContinueRun: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}:continue',
  },
  CopyAndUpgradeWorkspaceBookConnection: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books/{book_name}/{book_version}/connections/{connection_id}/copy-and-upgrade',
  },
  CopyFile: {
    method: 'POST',
    path: '/bishop.files.v1.FilesService/CopyFile',
  },
  CountConnectionUsage: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations:countConnectionUsage',
  },
  CountExceptionsByAssignee: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptions:countByAssignee',
  },
  CountExceptionsByAutomation: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptions:countByAutomation',
  },
  CountExceptionsByGroup: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptions:countByGroup',
  },
  CountOrganizationUsers: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/users:count',
  },
  CountTokens: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/generator/tokenize:count',
  },
  CountWorkspaces: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces:count',
  },
  CountWorkspaceUsers: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces:countUsers',
  },
  CreateAgent: {
    method: 'POST',
    path: '/api/v1/agents',
  },
  CreateAgentPlan: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan',
  },
  CreateArtifactStore: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifact-stores',
  },
  CreateArtifactType: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifact-types',
  },
  CreateAsset: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/assets',
  },
  CreateAutomation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations',
  },
  CreateAutomationSchedule: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/schedule',
  },
  CreateAutomationTrigger: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/triggers',
  },
  CreateBackend: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/backends',
  },
  CreateBackend2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/backends',
  },
  CreateCollection: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections',
  },
  CreateCredential: {
    method: 'POST',
    path: '/api/v1/credentials',
  },
  CreateCustomRole: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/customRoles',
  },
  CreateEval: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evals',
  },
  CreateEvalRun: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evalRuns',
  },
  CreateEvent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent}/events',
  },
  CreateException: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptions',
  },
  CreateFolder: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/folders',
  },
  CreateGuide: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/guides',
  },
  CreateGuideEntry: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/guideEntries',
  },
  CreateInvestigation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/findings/{finding}/investigations',
  },
  CreateMemoryBlock: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/memory-blocks',
  },
  CreateOAuthApp: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/oauthApps',
  },
  CreateOAuthApp2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/oauthApps',
  },
  CreateOrganization: {
    method: 'POST',
    path: '/api/v1/organizations',
  },
  CreatePermissionTemplate: {
    method: 'POST',
    path: '/agora.v1.RBACService/CreatePermissionTemplate',
  },
  CreatePersonalAccessToken: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/personal_access_tokens',
  },
  CreateRemoteConnection: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/remoteConnections',
  },
  CreateRoleTemplate: {
    method: 'POST',
    path: '/agora.v1.RBACService/CreateRoleTemplate',
  },
  CreateRun: {
    method: 'POST',
    path: '/jeeves.v1.RunService/CreateRun',
  },
  CreateRunAssistant: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}:runAssistant',
  },
  CreateSchedule: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/schedules',
  },
  CreateSecret: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/secrets',
  },
  CreateSecret2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/secrets',
  },
  CreateSecretType: {
    method: 'POST',
    path: '/api/v1/secretTypes',
  },
  CreateStepEval: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evals:step',
  },
  CreateStepEvalRun: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evalRuns:runStep',
  },
  CreateSubAgent: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/sub-agents',
  },
  CreateSubmission: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workUnits/{workUnit}/submissions',
  },
  CreateSupportAccessGrant: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/supportAccessGrants',
  },
  CreateSupportAccessGrant2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/supportAccessGrants',
  },
  'rain-v1-thread_service.CreateThread': {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads',
  },
  'zen-v1-thread_service.CreateThread': {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent}/threads',
  },
  CreateToolSource: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tool-sources',
  },
  CreateVariable: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/variables',
  },
  CreateVectorCollection: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections',
  },
  CreateVectorStore: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/vector-stores',
  },
  CreateWorkspace: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces',
  },
  CurrentUser: {
    method: 'GET',
    path: '/api/v1/me',
  },
  CurrentUserEffectivePreferences: {
    method: 'GET',
    path: '/api/v1/me/organizations/{organization}/workspaces/{workspace}/effective_preferences',
  },
  CurrentUserOrganizationPermissions: {
    method: 'GET',
    path: '/api/v1/me/organizations/{organization}/permissions',
  },
  CurrentUserOrganizationRoles: {
    method: 'GET',
    path: '/api/v1/me/organizations/{organization}/roles',
  },
  CurrentUserOrganizations: {
    method: 'GET',
    path: '/api/v1/me/organizations',
  },
  CurrentUserOrganizationWorkspaces: {
    method: 'GET',
    path: '/api/v1/me/organizations/{organization}/workspaces',
  },
  CurrentUserPermissions: {
    method: 'GET',
    path: '/api/v1/me/permissions',
  },
  CurrentUserWorkspacePermissions: {
    method: 'GET',
    path: '/api/v1/me/organizations/{organization}/workspaces/{workspace}/permissions',
  },
  CurrentUserWorkspaceRoles: {
    method: 'GET',
    path: '/api/v1/me/organizations/{organization}/workspaces/{workspace}/roles',
  },
  CurrentUserWorkspaces: {
    method: 'GET',
    path: '/api/v1/me/workspaces',
  },
  DeactivateAutomation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:deactivate',
  },
  DeactivatePlan: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan/active:deactivate',
  },
  DeactivateSchedule: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/schedules/{id}:deactivate',
  },
  DeactivateTrigger: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/triggers/{trigger_id}:deactivate',
  },
  DeclineAssignment: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workItems/{workItem}:decline',
  },
  DeclineInvitation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/invitations/{invitation}:decline',
  },
  DehydrateThread: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}:dehydrate',
  },
  DeleteAgent: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}',
  },
  DeleteAgentPlan: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan',
  },
  DeleteAllThreads: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads',
  },
  DeleteArtifact: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}',
  },
  DeleteArtifactStore: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifact-stores/{store_id}',
  },
  DeleteArtifactType: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifact-types/{type_id}',
  },
  DeleteAsset: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/assets/{asset}',
  },
  DeleteAutomation: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}',
  },
  DeleteAutomationSchedule: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/schedule',
  },
  DeleteAutomationTrigger: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/triggers/{trigger_id}',
  },
  DeleteBackend: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/backends/{backend}',
  },
  DeleteBackend2: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/backends/{backend}',
  },
  DeleteCollection: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}',
  },
  DeleteCollectionField: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}:deleteField',
  },
  DeleteCollectionRow: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}/rows/{row}',
  },
  DeleteCollectionRowsByFilter: {
    method: 'POST',
    path: '/bishop.collections.v1.CollectionRowsService/DeleteCollectionRowsByFilter',
  },
  DeleteCredential: {
    method: 'DELETE',
    path: '/api/v1/credentials/{credential_id}',
  },
  DeleteCustomRole: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/customRoles/{customRole}',
  },
  DeleteDraftAutomation: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/drafts',
  },
  DeleteEval: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evals/{evalId}',
  },
  DeleteEvent: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/events:delete',
  },
  DeleteFile: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/files/{file}',
  },
  DeleteFile2: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/files/{file}',
  },
  DeleteFolder: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/folders/{folder}',
  },
  DeleteGuide: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/guides/{guide}',
  },
  DeleteGuideEntry: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/guideEntries/{guideEntrie}',
  },
  DeleteMemoryBlock: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}',
  },
  DeleteOAuthApp: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization_id}/oauthApps/{id}',
  },
  DeleteOAuthApp2: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/oauthApps/{id}',
  },
  DeleteOrganization: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}',
  },
  DeleteRemoteConnection: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/remoteConnections/{id}',
  },
  DeleteSavedFilter: {
    method: 'DELETE',
    path: '/api/v1/saved-filters/{surface}/{id}',
  },
  DeleteSchedule: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/schedules/{id}',
  },
  DeleteSecret: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization_id}/secrets/{id}',
  },
  DeleteSecret2: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/secrets/{id}',
  },
  DeleteSecretType: {
    method: 'DELETE',
    path: '/api/v1/secretTypes/{secretType}',
  },
  DeleteSubAgent: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/sub-agents/{sub_agent_id}',
  },
  DeleteThread: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}',
  },
  DeleteToolSource: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tool-sources/{source_id}',
  },
  DeleteUser: {
    method: 'DELETE',
    path: '/api/v1/users/{user}',
  },
  DeleteVariable: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/variables/{variable_name}',
  },
  DeleteVectorCollection: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections/{collection}',
  },
  DeleteVectorStore: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}',
  },
  DeleteWorkspace: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}',
  },
  DeleteWorkspaceConnection: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations:deleteConnection',
  },
  DenyAccessRequest: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/invitations/{invitation}:denyAccess',
  },
  Deploy: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/agent:deploy',
  },
  DescribeGrammar: {
    method: 'POST',
    path: '/jarvis.v1.JarvisService/DescribeGrammar',
  },
  DescribeVectorCollection: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections/{collection}',
  },
  DiffAgentPlan: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan:diff',
  },
  DiffArtifacts: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifacts:diff',
  },
  DiffArtifactStores: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifact-stores:diff',
  },
  DiffArtifactTypes: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifact-types:diff',
  },
  DiffCompactor: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/compactor:diff',
  },
  DiffEmbedder: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/embedder:diff',
  },
  DiffFollowUpGenerator: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/follow-up:diff',
  },
  DiffGenerator: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/generator:diff',
  },
  DiffMemoryBlocks: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/memory-blocks:diff',
  },
  DiffSubAgents: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/sub-agents:diff',
  },
  DiffTools: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools:diff',
  },
  DiffToolSources: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tool-sources:diff',
  },
  DiffUtilityGenerator: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/utility-generator:diff',
  },
  DiffVariables: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/variables:diff',
  },
  DiffVectorStores: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/vector-stores:diff',
  },
  DisableAutomationSchedule: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:disableAutomationSchedule',
  },
  DisableTool: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}:disable',
  },
  DisableTools: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}:disable',
  },
  DisassociateRemoteConnection: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}/remote-connection/{remote_connection_id}',
  },
  DiscardArtifacts: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifacts:discard',
  },
  DiscoverIdentityProvider: {
    method: 'POST',
    path: '/api/v1/auth:discoverIdentityProvider',
  },
  DiscoverInventory: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}:discoverInventory',
  },
  DiscoverInventory2: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}:discoverInventory',
  },
  DownloadFile: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/files/{file}:download',
  },
  DownloadFile2: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/files/{file}:download',
  },
  DownloadFileStream: {
    method: 'POST',
    path: '/bishop.files.v1.FilesService/DownloadFileStream',
  },
  DuplicateAgent: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}:duplicate',
  },
  DuplicateAsset: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/assets/{asset}:duplicate',
  },
  DuplicateAutomation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:duplicate',
  },
  DuplicateFolder: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/folders/{folder}:duplicate',
  },
  EmbedAudio: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/embedder:embed-audio',
  },
  EmbedAudioBatch: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/embedder:embed-audio-batch',
  },
  EmbedImage: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/embedder:embed-image',
  },
  EmbedImageBatch: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/embedder:embed-image-batch',
  },
  EmbedText: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/embedder:embed-text',
  },
  EmbedTextBatch: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/embedder:embed-text-batch',
  },
  EmbedVideo: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/embedder:embed-video',
  },
  EmbedVideoBatch: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/embedder:embed-video-batch',
  },
  EnableAutomationSchedule: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:enableAutomationSchedule',
  },
  EnableTool: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}:enable',
  },
  EnableTools: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}:enable',
  },
  'grimoire-v1-agent_import_export.ExportAgent': {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agentBundles/{agentBundle}:export',
  },
  'rain-v1-agent_service.ExportAgent': {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}:export',
  },
  ExportAuditEvents: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/auditEvents:export',
  },
  ExportAutomation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:export',
  },
  ExportCollection: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}/rows:exportCsv',
  },
  ExportGraph: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/graph:export',
  },
  ExtractAutomationCodeConnections: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:extractCodeConnections',
  },
  ExtractBookFunction: {
    method: 'POST',
    path: '/jarvis.v1.JarvisService/ExtractBookFunction',
  },
  ExtractInput: {
    method: 'POST',
    path: '/jarvis.v1.JarvisService/ExtractInput',
  },
  ExtractOutput: {
    method: 'POST',
    path: '/jarvis.v1.JarvisService/ExtractOutput',
  },
  FindSharedNeighbors: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/entities:findSharedNeighbors',
  },
  ForkPublishedAutomation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:fork',
  },
  ForkThread: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}:fork',
  },
  Generate: {
    method: 'POST',
    path: '/api/v1/rain.v1.GeneratorService/Generate',
  },
  GenerateAssetDownloadUrl: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/assets/{asset}:generateDownloadUrl',
  },
  GenerateAutomationVisualization: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:generateVisualization',
  },
  GenerateDownloadUrl: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/files/{file}:generateDownloadUrl',
  },
  GenerateDownloadUrl2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/files/{file}:generateDownloadUrl',
  },
  GenerateSkeleton: {
    method: 'POST',
    path: '/jarvis.v1.JarvisService/GenerateSkeleton',
  },
  GenerateUploadUrl: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/files:generateUploadUrl',
  },
  GenerateUploadUrl2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/files:generateUploadUrl',
  },
  GetActivePlan: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan/active',
  },
  GetAgent: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}',
  },
  GetAgentPlan: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan',
  },
  GetAgentVersion: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/versions/{version}',
  },
  GetAgentVersionByTag: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/tags/{tag}',
  },
  GetArtifact: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}',
  },
  GetArtifactContent: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}:content',
  },
  GetArtifactDiff: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}:diff',
  },
  GetArtifactsStagingSummary: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifacts:staging',
  },
  GetAsset: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/assets/{asset}',
  },
  GetAuditEvent: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/auditEvents/{auditEvent}',
  },
  GetAuthorizationSnapshot: {
    method: 'POST',
    path: '/agora.v1.RBACService/GetAuthorizationSnapshot',
  },
  GetAutomation: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}',
  },
  GetAutomationRevision: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/revisions/{revision}',
  },
  GetAutomationSchedule: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/schedule',
  },
  GetAutomationVisualization: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/visualization',
  },
  GetBackend: {
    method: 'GET',
    path: '/api/v1/backends/{backend}',
  },
  GetBackend2: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/backends/{backend}',
  },
  GetBackend3: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/backends/{backend}',
  },
  GetCatalog: {
    method: 'GET',
    path: '/v1/organizations/{organization}/workspaces/{workspace}/catalog',
  },
  GetCatalog2: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/catalog',
  },
  GetCatalog3: {
    method: 'GET',
    path: '/v1/organizations/{organization}/workspaces/{workspace}/cartographer',
  },
  GetCatalog4: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/cartographer',
  },
  GetCockpitLive: {
    method: 'POST',
    path: '/sigma.v1.SigmaService/GetCockpitLive',
  },
  GetCockpitSnapshot: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/cockpitSnapshot',
  },
  GetCockpitTemplate: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/cockpitTemplate',
  },
  GetCollection: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}',
  },
  GetCollectionRow: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}/rows/{row}',
  },
  GetCollectionSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}/schema',
  },
  GetCompactor: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/compactor',
  },
  GetConnector: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/connectors/{connector}',
  },
  GetCredential: {
    method: 'GET',
    path: '/api/v1/credentials/{credential_id}',
  },
  GetCreditBalance: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/creditBalance',
  },
  GetCurrentQuarterGoals: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/currentQuarterGoals',
  },
  GetCurrentUserWorkspaceNotificationChannelPreferences: {
    method: 'GET',
    path: '/api/v1/me/organizations/{organization}/workspaces/{workspace}/notifications/{channel}/preferences',
  },
  GetCustomRole: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/customRoles/{customRole}',
  },
  GetDetectorRun: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/detectorRuns/{detectorRun}',
  },
  GetDynamicArtifactStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/artifact-stores:dynamic-config',
  },
  GetDynamicArtifactTypeConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/artifact-types:dynamic-config',
  },
  GetDynamicCompactorConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/compactor:dynamic-config',
  },
  GetDynamicCredentialConfigSchema: {
    method: 'POST',
    path: '/api/v1/credentials:dynamic-config',
  },
  GetDynamicEmbedderConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/embedder:dynamic-config',
  },
  GetDynamicExportFormatConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/export-formats:dynamic-config',
  },
  GetDynamicFollowUpGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/follow-up:dynamic-config',
  },
  GetDynamicGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/generator:dynamic-config',
  },
  GetDynamicImportFormatConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/import-formats:dynamic-config',
  },
  GetDynamicMemoryBlockConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/memory-blocks:dynamic-config',
  },
  GetDynamicSubAgentConfigSchema: {
    method: 'POST',
    path: '/api/v1/sub-agents:dynamic-config',
  },
  GetDynamicToolAdapterConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/tool-adapters:dynamic-config',
  },
  GetDynamicToolSourceConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/tool-sources:dynamic-config',
  },
  GetDynamicUtilityGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/utility-generator:dynamic-config',
  },
  GetDynamicVectorStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/vector-stores:dynamic-config',
  },
  GetEffectDelivery: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/effectDeliveries/{effectDeliverie}',
  },
  GetEmbedder: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/embedder',
  },
  GetEmbedderInfo: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/embedder-info',
  },
  GetEntity: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/entities/{entitie}',
  },
  GetEval: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evals/{evalId}',
  },
  GetEvalRun: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evalRuns/{evalRun}',
  },
  GetEvalSnapshot: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evals/{evalId}/snapshots/{snapshot}',
  },
  GetEvent: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent}/events/{event}',
  },
  GetEvents: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/events',
  },
  GetException: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptions/{exception}',
  },
  GetExecutionOutputs: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/executions/{execution}/outputs',
  },
  GetFact: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/facts/{fact}',
  },
  GetFileMetadata: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/files/{file}/metadata',
  },
  GetFileMetadata2: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/files/{file}/metadata',
  },
  'rain-v1-agent_service.GetFilterSchema': {
    method: 'GET',
    path: '/api/v1/agents:filter-schema',
  },
  'rain-v1-credential_service.GetFilterSchema': {
    method: 'GET',
    path: '/api/v1/credentials:filter-schema',
  },
  'rain-v1-schedule_service.GetFilterSchema': {
    method: 'GET',
    path: '/api/v1/schedules:filter-schema',
  },
  'rain-v1-thread_service.GetFilterSchema': {
    method: 'GET',
    path: '/api/v1/threads:filter-schema',
  },
  GetFinding: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/findings/{finding}',
  },
  GetFolder: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/folders/{folder}',
  },
  GetFolderTree: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/folders:tree',
  },
  GetFollowUpGenerator: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/follow-up',
  },
  GetGenerator: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/generator',
  },
  GetGlobalSchemaVersion: {
    method: 'POST',
    path: '/agora.v1.RBACService/GetGlobalSchemaVersion',
  },
  GetGuide: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/guides/{guide}',
  },
  GetGuideEntry: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/guideEntries/{guideEntrie}',
  },
  GetHermesExceptionContext: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptions/{exception}:hermesContext',
  },
  GetInvestigation: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/findings/{finding}/investigations/{investigation}',
  },
  GetInvitation: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/invitations/{invitation}',
  },
  GetMemoryBlock: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}',
  },
  GetMetric: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/metrics/{metric}',
  },
  GetModelInfo: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/generator:model-info',
  },
  GetNextCopyName: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:nextCopyName',
  },
  GetOAuthApp: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/oauthApps/{id}',
  },
  GetOAuthApp2: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/oauthApps/{id}',
  },
  GetOntology: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/ontology',
  },
  GetOrganization: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}',
  },
  GetOrganizationPreferences: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/preferences',
  },
  GetOrgOwners: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/orgOwners',
  },
  GetPermissionTemplate: {
    method: 'POST',
    path: '/agora.v1.RBACService/GetPermissionTemplate',
  },
  GetPersonalAccessToken: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/personal_access_tokens/{personal_access_token}',
  },
  GetPostAutomationPhase: {
    method: 'POST',
    path: '/grimoire.v1.AutomationPhaseService/GetPostAutomationPhase',
  },
  GetQueue: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/queue',
  },
  GetRemoteConnection: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/remoteConnections/{id}',
  },
  GetRoleTemplate: {
    method: 'POST',
    path: '/agora.v1.RBACService/GetRoleTemplate',
  },
  GetRun: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}',
  },
  GetRunCodeManifest: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}:codeManifest',
  },
  GetSchedule: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/schedules/{id}',
  },
  GetSecret: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/secrets/{id}',
  },
  GetSecret2: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/secrets/{id}',
  },
  GetSecretType: {
    method: 'GET',
    path: '/api/v1/secretTypes/{secretType}',
  },
  GetServiceInfo: {
    method: 'GET',
    path: '/api/v1/info',
  },
  GetStaticArtifactStoreConfigSchema: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/artifact-stores:static-config',
  },
  GetStaticArtifactTypeConfigSchema: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/artifact-types:static-config',
  },
  GetStaticCompactorConfigSchema: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/compactor:static-config',
  },
  GetStaticCredentialConfigSchema: {
    method: 'GET',
    path: '/api/v1/credentials:static-config',
  },
  GetStaticEmbedderConfigSchema: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/embedder:static-config',
  },
  GetStaticExportFormatConfigSchema: {
    method: 'GET',
    path: '/api/v1/agents/export-formats:static-config',
  },
  GetStaticFollowUpGeneratorConfigSchema: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/follow-up:static-config',
  },
  GetStaticGeneratorConfigSchema: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/generator:static-config',
  },
  GetStaticImportFormatConfigSchema: {
    method: 'GET',
    path: '/api/v1/agents/import-formats:static-config',
  },
  GetStaticMemoryBlockConfigSchema: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/memory-blocks:static-config',
  },
  GetStaticSubAgentConfigSchema: {
    method: 'GET',
    path: '/api/v1/sub-agents:static-config',
  },
  GetStaticToolAdapterConfigSchema: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/tool-adapters:static-config',
  },
  GetStaticToolSourceConfigSchema: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/tool-sources:static-config',
  },
  GetStaticUtilityGeneratorConfigSchema: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/utility-generator:static-config',
  },
  GetStaticVectorStoreConfigSchema: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/vector-stores:static-config',
  },
  GetSubmission: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workUnits/{workUnit}/submissions/{submission}',
  },
  GetSupportAccessGrant: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/supportAccessGrants/{supportAccessGrant}',
  },
  GetSupportAccessGrant2: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/supportAccessGrants/{supportAccessGrant}',
  },
  GetSyncJob: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/connectors/{connector}/syncJobs/{syncJob}',
  },
  'rain-v1-thread_service.GetThread': {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}',
  },
  'zen-v1-thread_service.GetThread': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent}/threads/{thread}',
  },
  GetThreadAgentCard: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/card',
  },
  GetThreadContext: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/context',
  },
  GetThreadCostSummary: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/cost',
  },
  GetThreadCustomizations: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/customizations',
  },
  GetThreadMemory: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/memory',
  },
  GetThreadMemoryBlock: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/memory/{block_id}',
  },
  GetThreadMessage: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent}/threads/{thread}/messages/{message}',
  },
  GetTool: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{tool_id}',
  },
  GetToolAdapter: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters/{adapter_id}',
  },
  GetToolAdapterChain: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters:chain',
  },
  GetTotalInfusedCredits: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/totalInfusedCredits',
  },
  GetUserBasicInfo: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/users/{user}',
  },
  GetUserPreferences: {
    method: 'GET',
    path: '/api/v1/me/preferences',
  },
  GetUserUnreadNotificationCountForWorkspace: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/notifications:unreadCount',
  },
  GetUtilityGenerator: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/utility-generator',
  },
  GetUtilityGeneratorModelInfo: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/utility-generator:model-info',
  },
  GetWorkItem: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workItems/{workItem}',
  },
  GetWorkspace: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}',
  },
  GetWorkspaceNotificationChannelPreferences: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/notifications/{channel}/preferences',
  },
  GetWorkspacePreferences: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/preferences',
  },
  GetWorkUnit: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workUnits/{workUnit}',
  },
  GrepArtifacts: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifacts:grep',
  },
  IdentifyStepValueSlots: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/valueSlots',
  },
  'grimoire-v1-agent_import_export.ImportAgent': {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agentBundles:import',
  },
  'rain-v1-agent_service.ImportAgent': {
    method: 'POST',
    path: '/api/v1/agents:import',
  },
  ImportAutomation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations:import',
  },
  ImportCollection: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}/rows:importCsv',
  },
  InfuseCredits: {
    method: 'POST',
    path: '/mint.v1.CreditService/InfuseCredits',
  },
  InsertCollectionRow: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}/rows',
  },
  InspectStepConfig: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/stepConfig',
  },
  InviteOrganizationUsers: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/users:invite',
  },
  InviteWorkspaceUsers: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/users:invite',
  },
  InvokeAutomation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:invoke',
  },
  InvokeScheduledAutomation: {
    method: 'POST',
    path: '/grimoire.v1.AutomationService/InvokeScheduledAutomation',
  },
  InvokeTool: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools:invoke',
  },
  LeaveWorkspace: {
    method: 'POST',
    path: '/api/v1/me/organizations/{organization}/workspaces/{workspace}:leave',
  },
  ListAgentLabels: {
    method: 'GET',
    path: '/api/v1/agents:labels',
  },
  ListAgents: {
    method: 'GET',
    path: '/api/v1/agents',
  },
  ListAgentVersions: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/versions',
  },
  ListAllSchedules: {
    method: 'GET',
    path: '/api/v1/schedules',
  },
  ListAllSecrets: {
    method: 'POST',
    path: '/kognitos.gringotts.v1.SecretService/ListAllSecrets',
  },
  ListAllThreads: {
    method: 'GET',
    path: '/api/v1/threads',
  },
  ListArtifacts: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifacts',
  },
  ListArtifactStoreDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/artifact-stores:dynamic-enum-values',
  },
  ListArtifactStoreKinds: {
    method: 'GET',
    path: '/api/v1/artifact-stores/kinds',
  },
  ListArtifactStores: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifact-stores',
  },
  ListArtifactTypeDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/artifact-types:dynamic-enum-values',
  },
  ListArtifactTypeKinds: {
    method: 'GET',
    path: '/api/v1/artifact-types/kinds',
  },
  ListArtifactTypes: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifact-types',
  },
  ListAssets: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/assets',
  },
  ListAuditEvents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/auditEvents',
  },
  ListAutomationRevisions: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/revisions',
  },
  ListAutomationRevisionSummaries: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/revisions:listSummaries',
  },
  ListAutomations: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations',
  },
  ListAutomationSummaries: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations:listSummaries',
  },
  ListAutomationTriggers: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/triggers',
  },
  ListAvailablePermissions: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/personal_access_tokens:availablePermissions',
  },
  ListBackends: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/backends',
  },
  ListBackends2: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/backends',
  },
  ListBackendTypes: {
    method: 'GET',
    path: '/api/v1/backendTypes',
  },
  ListCollectionRows: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}/rows:query',
  },
  ListCollections: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections',
  },
  ListCollectionTags: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections:tags',
  },
  ListCompactorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/compactors:dynamic-enum-values',
  },
  ListCompactorKinds: {
    method: 'GET',
    path: '/api/v1/compactors/kinds',
  },
  ListConnectors: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/connectors',
  },
  ListCredentialDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/credentials:dynamic-enum-values',
  },
  ListCredentialKinds: {
    method: 'GET',
    path: '/api/v1/credentials/kinds',
  },
  ListCredentials: {
    method: 'GET',
    path: '/api/v1/credentials',
  },
  ListCredentialStoreKinds: {
    method: 'GET',
    path: '/api/v1/credential-stores/kinds',
  },
  ListCurrentUserPendingInvitations: {
    method: 'GET',
    path: '/api/v1/me/invitations',
  },
  ListCurrentUserWorkspaceSupportedNotificationChannels: {
    method: 'GET',
    path: '/api/v1/me/organizations/{organization}/workspaces/{workspace}/notificationChannels',
  },
  ListCustomRoles: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/customRoles',
  },
  ListDefaultInputsHistory: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:listDefaultInputsHistory',
  },
  ListDetectorGroups: {
    method: 'GET',
    path: '/api/v1/findings/detectors:groups',
  },
  ListDetectorRuns: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/detectorRuns',
  },
  ListDetectors: {
    method: 'GET',
    path: '/api/v1/findings/detectors',
  },
  ListEffectDeliveries: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/effectDeliveries',
  },
  ListEmbedderDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/embedders:dynamic-enum-values',
  },
  ListEmbedderKinds: {
    method: 'GET',
    path: '/api/v1/embedders/kinds',
  },
  ListEntities: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/entities',
  },
  ListEvalRuns: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evalRuns',
  },
  ListEvals: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evals',
  },
  ListEvents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent}/events',
  },
  ListExceptionClusters: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptionClusters',
  },
  ListExceptionGroups: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptionGroups',
  },
  ListExceptionResolutions: {
    method: 'POST',
    path: '/astral.v1.ExceptionManagerService/ListExceptionResolutions',
  },
  ListExceptions: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptions',
  },
  ListExportFormatKinds: {
    method: 'GET',
    path: '/api/v1/agents/export-formats/kinds',
  },
  ListFactHistory: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/facts:listFactHistory',
  },
  ListFacts: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/facts',
  },
  ListFindings: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/findings',
  },
  ListFolders: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/folders',
  },
  ListFollowUpGeneratorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/follow-ups:dynamic-enum-values',
  },
  ListFollowUpGeneratorKinds: {
    method: 'GET',
    path: '/api/v1/follow-ups/kinds',
  },
  ListGeneratorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/generators:dynamic-enum-values',
  },
  ListGeneratorKinds: {
    method: 'GET',
    path: '/api/v1/generators/kinds',
  },
  ListGuideApplications: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/guideEntries/{guideEntrie}/applications',
  },
  ListGuideEntries: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/guideEntries',
  },
  ListGuideEntryVersions: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/guideEntries/{guideEntrie}:listVersions',
  },
  ListGuides: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/guides',
  },
  ListImportFormatKinds: {
    method: 'GET',
    path: '/api/v1/agents/import-formats/kinds',
  },
  ListInvestigations: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/findings/{finding}/investigations',
  },
  ListMemoryBlockDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/memory-blocks:dynamic-enum-values',
  },
  ListMemoryBlockKinds: {
    method: 'GET',
    path: '/api/v1/memory-blocks/kinds',
  },
  ListMemoryBlocks: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/memory-blocks',
  },
  ListMetrics: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/metrics',
  },
  ListOAuthApps: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/oauthApps',
  },
  ListOAuthApps2: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/oauthApps',
  },
  ListOrganizationOwners: {
    method: 'POST',
    path: '/agora.v1.OrganizationService/ListOrganizationOwners',
  },
  ListOrganizationRoles: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/roles',
  },
  ListOrganizationUserInvites: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/invites',
  },
  ListOrganizationUsers: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/users',
  },
  ListPermissions: {
    method: 'POST',
    path: '/agora.v1.RBACService/ListPermissions',
  },
  ListPermissionTemplates: {
    method: 'POST',
    path: '/agora.v1.RBACService/ListPermissionTemplates',
  },
  ListPersonalAccessTokens: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/personal_access_tokens',
  },
  ListQueuedThreadMessages: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent}/threads/{thread}/messages:queued',
  },
  ListRemoteConnections: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/remoteConnections',
  },
  ListRoles: {
    method: 'POST',
    path: '/agora.v1.RBACService/ListRoles',
  },
  ListRoleTemplates: {
    method: 'POST',
    path: '/agora.v1.RBACService/ListRoleTemplates',
  },
  ListRunEvents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/events',
  },
  ListRunExecutions: {
    method: 'POST',
    path: '/jeeves.v1.RunService/ListRunExecutions',
  },
  ListRuns: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs',
  },
  ListSavedFilters: {
    method: 'GET',
    path: '/api/v1/saved-filters/{surface}',
  },
  ListSchedules: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/schedules',
  },
  ListSecrets: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/secrets',
  },
  ListSecrets2: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/secrets',
  },
  ListSecretTypes: {
    method: 'GET',
    path: '/api/v1/secretTypes',
  },
  ListSubAgentKinds: {
    method: 'GET',
    path: '/api/v1/sub-agents/kinds',
  },
  ListSubAgents: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/sub-agents',
  },
  ListSupportAccessGrants: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/supportAccessGrants',
  },
  ListSupportAccessGrants2: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/supportAccessGrants',
  },
  ListSyncJobs: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/connectors/{connector}/syncJobs',
  },
  ListThreadMessages: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent}/threads/{thread}/messages',
  },
  'rain-v1-thread_service.ListThreads': {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads',
  },
  'zen-v1-thread_service.ListThreads': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent}/threads',
  },
  ListToolAdapterDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/tool-adapters:dynamic-enum-values',
  },
  ListToolAdapterKinds: {
    method: 'GET',
    path: '/api/v1/tool-adapters/kinds',
  },
  ListToolAdapters: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  'rain-v1-thread_service.ListTools': {
    method: 'POST',
    path: '/api/v1/rain.v1.ThreadService/ListTools',
  },
  'rain-v1-tool_catalog_service.ListTools': {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools',
  },
  ListToolSourceDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/tool-sources:dynamic-enum-values',
  },
  ListToolSourceKinds: {
    method: 'GET',
    path: '/api/v1/tool-sources/kinds',
  },
  ListToolSources: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tool-sources',
  },
  ListUserNotifications: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/notifications',
  },
  ListUserNotifications2: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/notifications',
  },
  ListUserRoles: {
    method: 'POST',
    path: '/agora.v1.RBACService/ListUserRoles',
  },
  ListUtilityGeneratorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/utility-generators:dynamic-enum-values',
  },
  ListVariables: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/variables',
  },
  ListVectorCollections: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections',
  },
  ListVectorStoreDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/vector-stores:dynamic-enum-values',
  },
  ListVectorStoreKinds: {
    method: 'GET',
    path: '/api/v1/vector-stores/kinds',
  },
  ListVectorStores: {
    method: 'GET',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/vector-stores',
  },
  ListWorkItemKinds: {
    method: 'GET',
    path: '/api/v1/workItemKinds',
  },
  ListWorkItems: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workItems',
  },
  ListWorkspaceDetectorGroups: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workspaceDetectors:groups',
  },
  ListWorkspaceDetectors: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workspaceDetectors',
  },
  ListWorkspacePermissions: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/permissions',
  },
  ListWorkspaceRoles: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/roles',
  },
  ListWorkspaces: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces',
  },
  ListWorkspaceSupportedNotificationChannels: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/notificationChannels',
  },
  ListWorkspaceTags: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/assets:tags',
  },
  ListWorkspaceUserInvites: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/invites',
  },
  ListWorkspaceUsers: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/users',
  },
  ListWorkUnits: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workUnits',
  },
  LookupEntity: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/entities:lookup',
  },
  MarkExceptionResolved: {
    method: 'POST',
    path: '/astral.v1.ExceptionManagerService/MarkExceptionResolved',
  },
  MarkNotificationsAsRead: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/notifications:markRead',
  },
  MarkNotificationsAsRead2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/notifications:markRead',
  },
  MarkNotificationsTillNowRead: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/notifications:markAllRead',
  },
  MarkNotificationsTillNowRead2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/notifications:markAllRead',
  },
  MarkStep: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan/active/phases/{phase_index}/steps/{step_index}:mark',
  },
  MarkWorkItemPreparationStarted: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workItems/{workItem}:markPreparationStarted',
  },
  MigrateConnectionAliases: {
    method: 'POST',
    path: '/grimoire.v1.AutomationService/MigrateConnectionAliases',
  },
  MoveAsset: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/assets/{asset}:move',
  },
  MoveAutomation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:move',
  },
  MoveFolder: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/folders/{folder}:move',
  },
  OnboardUserAndOrganization: {
    method: 'POST',
    path: '/api/v1/onboarding',
  },
  PaginateValueContent: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/files/{file}:paginateValueContent',
  },
  PatchRunStep: {
    method: 'POST',
    path: '/jeeves.v1.RunService/PatchRunStep',
  },
  PatchStep: {
    method: 'POST',
    path: '/astral.v1.ExceptionManagerService/PatchStep',
  },
  PauseRun: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}:pause',
  },
  PrepareCodeManifest: {
    method: 'POST',
    path: '/jarvis.v1.JarvisService/PrepareCodeManifest',
  },
  PreviewAutomationSchedule: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:previewSchedule',
  },
  PreviewToolAdapterChain: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters:preview',
  },
  PromoteActivePlan: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan:promote',
  },
  PromoteParamsToCode: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/promotedParams',
  },
  PublishAutomation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:publish',
  },
  PublishCollection: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}:publish',
  },
  QueryAutomation: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:query',
  },
  QueryAutomationEstimates: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/dashboards:queryAutomationEstimates',
  },
  QueryAutomationRunAggregates: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}:automationRunAggregates',
  },
  QueryDailyRunAggregates: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}:dailyRunAggregates',
  },
  QueryExceptionBreakdown: {
    method: 'POST',
    path: '/sigma.v1.SigmaService/QueryExceptionBreakdown',
  },
  QueryExceptionInsights: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptions:queryInsights',
  },
  QueryFindingMetrics: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/findings:queryMetrics',
  },
  QueryGuideStats: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/guideEntries:queryStats',
  },
  QueryInsights: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/dashboards:queryInsights',
  },
  QueryMetrics: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/metrics:query',
  },
  QueryRunMetrics: {
    method: 'POST',
    path: '/jeeves.v1.metrics.RunMetricsService/QueryRunMetrics',
  },
  QueryWorkspaceUsersEnabledForNotificationType: {
    method: 'POST',
    path: '/agora.v1.NotificationPreferenceService/QueryWorkspaceUsersEnabledForNotificationType',
  },
  ReactivateUser: {
    method: 'POST',
    path: '/api/v1/users/{user}:reactivate',
  },
  ReactivateWorkspaceBookConnection: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}:reactivate',
  },
  ReadExceptionValue: {
    method: 'POST',
    path: '/astral.v1.ExceptionManagerService/ReadExceptionValue',
  },
  RefreshAssetContent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/assets/{asset}:refreshContent',
  },
  RefreshSecret: {
    method: 'POST',
    path: '/kognitos.gringotts.v1.SecretService/RefreshSecret',
  },
  RehydrateThread: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}:rehydrate',
  },
  RekeyWorkItems: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workItems:rekey',
  },
  RemoveAgentPlanPhase: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}',
  },
  RemoveAgentPlanStep: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps/{step_index}',
  },
  RemoveAllToolAdapters: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  RemoveAutomationConnections: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:removeConnections',
  },
  RemoveOrganizationUsers: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/users:remove',
  },
  RemoveTestCase: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evals/{evalId}/testCases/{test_case_id}',
  },
  RemoveToolAdapter: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters/{adapter_id}',
  },
  RemoveWorkspaceBookConnection: {
    method: 'POST',
    path: '/bdk.v2.LibraryService/RemoveWorkspaceBookConnection',
  },
  RemoveWorkspaceBookConnectionAgentTriggerInstance: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}/agent-triggers/{trigger_instance_id}',
  },
  RemoveWorkspaceBookConnectionPollInstance: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}/polls/{poll_instance_id}',
  },
  RemoveWorkspaceBookConnectionTriggerInstance: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}/triggers/{trigger_instance_id}',
  },
  RemoveWorkspaceUsers: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/users:remove',
  },
  RenameAutomation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:rename',
  },
  ReorderAgentPlanPhases: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan/phases:reorder',
  },
  ReorderAgentPlanSteps: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps:reorder',
  },
  ReorderToolAdapters: {
    method: 'PUT',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  ReplaceFileContent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/files/{file}:replaceContent',
  },
  ReplaceMemoryContent: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}:replace',
  },
  ReplayRun: {
    method: 'POST',
    path: '/jeeves.v1.RunService/ReplayRun',
  },
  RequestOrganizationAccess: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/access:request',
  },
  RequestWorkspaceAccess: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/access:request',
  },
  ResetCockpitTemplate: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/cockpitTemplate:reset',
  },
  ResetConfig: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/agent:reset',
  },
  ResetEvents: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/events:reset',
  },
  ResetPlan: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan/active:reset',
  },
  ResolveDefaultCockpitTemplate: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/cockpitTemplate:resolve',
  },
  RestartRemoteConnection: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/remoteConnections:restartRemoteConnection',
  },
  RestoreAgentVersion: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/versions/{version}:restore',
  },
  RestoreAutomation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:restore',
  },
  RestoreEvent: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/events:restore',
  },
  ResumeMessageStream: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent}/threads/{thread}:resumeStream',
  },
  ResumeMessageStreamSse: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent}/threads/{thread}:resumeStreamSse',
  },
  ResumeRun: {
    method: 'POST',
    path: '/jeeves.v1.RunService/ResumeRun',
  },
  RetrieveAllWorkspaceBookConnections: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections',
  },
  RetrieveBook: {
    method: 'GET',
    path: '/api/v1/books/{name}/{version}',
  },
  RetrieveBookConcepts: {
    method: 'GET',
    path: '/api/v1/books/{name}/{version}/concepts',
  },
  RetrieveBookProcedures: {
    method: 'GET',
    path: '/api/v1/books/{name}/{version}/procedures',
  },
  RetrieveBooks: {
    method: 'GET',
    path: '/api/v1/books',
  },
  RetrieveBookVersions: {
    method: 'GET',
    path: '/api/v1/books/{name}/versions',
  },
  RetrieveLatestBooks: {
    method: 'GET',
    path: '/api/v1/books:latest',
  },
  RetrieveLatestWorkspaceBooks: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books:latest',
  },
  RetrieveTags: {
    method: 'GET',
    path: '/api/v1/tags',
  },
  RetrieveWorkspaceAgentTriggerInstances: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/agent-triggers',
  },
  RetrieveWorkspaceBook: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books/{name}/{version}',
  },
  RetrieveWorkspaceBookConcepts: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books/{name}/{version}/concepts',
  },
  RetrieveWorkspaceBookConnection: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}',
  },
  RetrieveWorkspaceBookConnectionDiscoverables: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}/discoverables',
  },
  RetrieveWorkspaceBookConnectionProcedures: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}/procedures',
  },
  RetrieveWorkspaceBookConnections: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books/{book_name}/{book_version}/connections',
  },
  RetrieveWorkspaceBookConnectionsByIds: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections:batchGet',
  },
  RetrieveWorkspaceBookConnectionUserInfo: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}/user-info',
  },
  RetrieveWorkspaceBookProcedures: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books/{name}/{version}/procedures',
  },
  RetrieveWorkspaceBooks: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books',
  },
  RetrieveWorkspaceBookVersions: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books/{name}/versions',
  },
  RetrieveWorkspacePollInstances: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/polls',
  },
  RetrieveWorkspaceTags: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/tags',
  },
  RetrieveWorkspaceTriggerInstances: {
    method: 'GET',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/triggers',
  },
  RetryEffectDelivery: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/effectDeliveries/{effectDeliverie}:retry',
  },
  RetryExceptions: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptions:retry',
  },
  RetryRunStep: {
    method: 'POST',
    path: '/jeeves.v1.RunService/RetryRunStep',
  },
  RetryStep: {
    method: 'POST',
    path: '/astral.v1.ExceptionManagerService/RetryStep',
  },
  ReverseResolution: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/facts/{fact}:reverseResolution',
  },
  RevertGuideEntry: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/guideEntries/{guideEntrie}:revert',
  },
  RevokeOrganizationUserInvite: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/invitations/{invitation}:revoke',
  },
  RevokePersonalAccessToken: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/personal_access_tokens/{personal_access_token}:revoke',
  },
  RevokeSupportAccessGrant: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/supportAccessGrants/{supportAccessGrant}:revoke',
  },
  RevokeSupportAccessGrant2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/supportAccessGrants/{supportAccessGrant}:revoke',
  },
  RevokeWorkspaceUserInvite: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/invitations/{invitation}:revoke',
  },
  RevokeWorkUnitInputAcceptance: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workUnits/{workUnit}:revokeInputAcceptance',
  },
  RunActivatePlan: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan:activate',
  },
  RunActivateSchedule: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/schedules/{id}:activate',
  },
  RunAddAgentPlanPhase: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan/phases',
  },
  RunAddAgentPlanStep: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps',
  },
  RunAddToolAdapter: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  RunClearCompactor: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/compactor',
  },
  RunClearEmbedder: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/embedder',
  },
  RunClearFollowUpGenerator: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/follow-up',
  },
  RunClearGenerator: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/generator',
  },
  RunClearThreadMemory: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/memory/{block_id}',
  },
  RunClearUtilityGenerator: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/utility-generator',
  },
  RunCode: {
    method: 'POST',
    path: '/api/v1/organizations/{start_execution.organization_id}/workspaces/{start_execution.workspace_id}/executions:run',
  },
  RunCommitArtifacts: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifacts:commit',
  },
  RunCountTokens: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/generator/tokenize:count',
  },
  RunCreateAgent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents',
  },
  RunCreateAgentPlan: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan',
  },
  RunCreateArtifactStore: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifact-stores',
  },
  RunCreateArtifactType: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifact-types',
  },
  RunCreateCredential: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/credentials',
  },
  RunCreateMemoryBlock: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/memory-blocks',
  },
  RunCreateSchedule: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/schedules',
  },
  RunCreateSubAgent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/sub-agents',
  },
  RunCreateThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads',
  },
  RunCreateToolSource: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tool-sources',
  },
  RunCreateVariable: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/variables',
  },
  RunCreateVectorCollection: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections',
  },
  RunCreateVectorStore: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/vector-stores',
  },
  RunDeactivatePlan: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan/active:deactivate',
  },
  RunDeactivateSchedule: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/schedules/{id}:deactivate',
  },
  RunDehydrateThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}:dehydrate',
  },
  RunDeleteAgent: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}',
  },
  RunDeleteAgentPlan: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan',
  },
  RunDeleteAllThreads: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads',
  },
  RunDeleteArtifact: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}',
  },
  RunDeleteArtifactStore: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifact-stores/{store_id}',
  },
  RunDeleteArtifactType: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifact-types/{type_id}',
  },
  RunDeleteCredential: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/credentials/{credential_id}',
  },
  RunDeleteEvent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/events:delete',
  },
  RunDeleteMemoryBlock: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}',
  },
  RunDeleteSavedFilter: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/saved-filters/{surface}/{id}',
  },
  RunDeleteSchedule: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/schedules/{id}',
  },
  RunDeleteSubAgent: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/sub-agents/{sub_agent_id}',
  },
  RunDeleteThread: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}',
  },
  RunDeleteToolSource: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tool-sources/{source_id}',
  },
  RunDeleteVariable: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/variables/{variable_name}',
  },
  RunDeleteVectorCollection: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections/{collection}',
  },
  RunDeleteVectorStore: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}',
  },
  RunDeploy: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/agent:deploy',
  },
  RunDescribeVectorCollection: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections/{collection}',
  },
  RunDetectors: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/findings/detectors:run',
  },
  RunDiffAgentPlan: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan:diff',
  },
  RunDiffArtifacts: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifacts:diff',
  },
  RunDiffArtifactStores: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifact-stores:diff',
  },
  RunDiffArtifactTypes: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifact-types:diff',
  },
  RunDiffCompactor: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/compactor:diff',
  },
  RunDiffEmbedder: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/embedder:diff',
  },
  RunDiffFollowUpGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/follow-up:diff',
  },
  RunDiffGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/generator:diff',
  },
  RunDiffMemoryBlocks: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/memory-blocks:diff',
  },
  RunDiffSubAgents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/sub-agents:diff',
  },
  RunDiffTools: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools:diff',
  },
  RunDiffToolSources: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tool-sources:diff',
  },
  RunDiffUtilityGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/utility-generator:diff',
  },
  RunDiffVariables: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/variables:diff',
  },
  RunDiffVectorStores: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/vector-stores:diff',
  },
  RunDisableTool: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}:disable',
  },
  RunDisableTools: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}:disable',
  },
  RunDiscardArtifacts: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifacts:discard',
  },
  RunDuplicateAgent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}:duplicate',
  },
  RunEmbedAudio: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/embedder:embed-audio',
  },
  RunEmbedAudioBatch: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/embedder:embed-audio-batch',
  },
  RunEmbedImage: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/embedder:embed-image',
  },
  RunEmbedImageBatch: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/embedder:embed-image-batch',
  },
  RunEmbedText: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/embedder:embed-text',
  },
  RunEmbedTextBatch: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/embedder:embed-text-batch',
  },
  RunEmbedVideo: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/embedder:embed-video',
  },
  RunEmbedVideoBatch: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/embedder:embed-video-batch',
  },
  RunEnableTool: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}:enable',
  },
  RunEnableTools: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}:enable',
  },
  RunExportAgent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}:export',
  },
  RunForkThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}:fork',
  },
  RunGenerate: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/rain.v1.GeneratorService/Generate',
  },
  RunGetActivePlan: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan/active',
  },
  RunGetAgent: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}',
  },
  RunGetAgentPlan: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan',
  },
  RunGetAgentVersion: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/versions/{version}',
  },
  RunGetAgentVersionByTag: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/tags/{tag}',
  },
  RunGetArtifact: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}',
  },
  RunGetArtifactContent: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}:content',
  },
  RunGetArtifactDiff: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}:diff',
  },
  RunGetArtifactsStagingSummary: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifacts:staging',
  },
  RunGetCompactor: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/compactor',
  },
  RunGetCredential: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/credentials/{credential_id}',
  },
  RunGetDynamicArtifactStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/artifact-stores:dynamic-config',
  },
  RunGetDynamicArtifactTypeConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/artifact-types:dynamic-config',
  },
  RunGetDynamicCompactorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/compactor:dynamic-config',
  },
  RunGetDynamicCredentialConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/credentials:dynamic-config',
  },
  RunGetDynamicEmbedderConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/embedder:dynamic-config',
  },
  RunGetDynamicExportFormatConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/export-formats:dynamic-config',
  },
  RunGetDynamicFollowUpGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/follow-up:dynamic-config',
  },
  RunGetDynamicGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/generator:dynamic-config',
  },
  RunGetDynamicImportFormatConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/import-formats:dynamic-config',
  },
  RunGetDynamicMemoryBlockConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/memory-blocks:dynamic-config',
  },
  RunGetDynamicSubAgentConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/sub-agents:dynamic-config',
  },
  RunGetDynamicToolAdapterConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/tool-adapters:dynamic-config',
  },
  RunGetDynamicToolSourceConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/tool-sources:dynamic-config',
  },
  RunGetDynamicUtilityGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/utility-generator:dynamic-config',
  },
  RunGetDynamicVectorStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/vector-stores:dynamic-config',
  },
  RunGetEmbedder: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/embedder',
  },
  RunGetEmbedderInfo: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/embedder-info',
  },
  RunGetEvents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/events',
  },
  'rain-v1-run_scoped-agent_service.RunGetFilterSchema': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents:filter-schema',
  },
  'rain-v1-run_scoped-credential_service.RunGetFilterSchema': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/credentials:filter-schema',
  },
  'rain-v1-run_scoped-schedule_service.RunGetFilterSchema': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/schedules:filter-schema',
  },
  'rain-v1-run_scoped-thread_service.RunGetFilterSchema': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/threads:filter-schema',
  },
  RunGetFollowUpGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/follow-up',
  },
  RunGetGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/generator',
  },
  RunGetMemoryBlock: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}',
  },
  RunGetModelInfo: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/generator:model-info',
  },
  RunGetQueue: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/queue',
  },
  RunGetSchedule: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/schedules/{id}',
  },
  RunGetServiceInfo: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/info',
  },
  RunGetStaticArtifactStoreConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/artifact-stores:static-config',
  },
  RunGetStaticArtifactTypeConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/artifact-types:static-config',
  },
  RunGetStaticCompactorConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/compactor:static-config',
  },
  RunGetStaticCredentialConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/credentials:static-config',
  },
  RunGetStaticEmbedderConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/embedder:static-config',
  },
  RunGetStaticExportFormatConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/export-formats:static-config',
  },
  RunGetStaticFollowUpGeneratorConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/follow-up:static-config',
  },
  RunGetStaticGeneratorConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/generator:static-config',
  },
  RunGetStaticImportFormatConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/import-formats:static-config',
  },
  RunGetStaticMemoryBlockConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/memory-blocks:static-config',
  },
  RunGetStaticSubAgentConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/sub-agents:static-config',
  },
  RunGetStaticToolAdapterConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/tool-adapters:static-config',
  },
  RunGetStaticToolSourceConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/tool-sources:static-config',
  },
  RunGetStaticUtilityGeneratorConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/utility-generator:static-config',
  },
  RunGetStaticVectorStoreConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/vector-stores:static-config',
  },
  RunGetThread: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}',
  },
  RunGetThreadAgentCard: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/card',
  },
  RunGetThreadContext: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/context',
  },
  RunGetThreadCostSummary: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/cost',
  },
  RunGetThreadCustomizations: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/customizations',
  },
  RunGetThreadMemory: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/memory',
  },
  RunGetThreadMemoryBlock: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/memory/{block_id}',
  },
  RunGetTool: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{tool_id}',
  },
  RunGetToolAdapter: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters/{adapter_id}',
  },
  RunGetToolAdapterChain: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters:chain',
  },
  RunGetUtilityGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/utility-generator',
  },
  RunGetUtilityGeneratorModelInfo: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/utility-generator:model-info',
  },
  RunGrepArtifacts: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifacts:grep',
  },
  RunImportAgent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents:import',
  },
  RunInvokeTool: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools:invoke',
  },
  RunListAgentLabels: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents:labels',
  },
  RunListAgents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents',
  },
  RunListAgentVersions: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/versions',
  },
  RunListAllSchedules: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/schedules',
  },
  RunListAllThreads: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/threads',
  },
  RunListArtifacts: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifacts',
  },
  RunListArtifactStoreDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/artifact-stores:dynamic-enum-values',
  },
  RunListArtifactStoreKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/artifact-stores/kinds',
  },
  RunListArtifactStores: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifact-stores',
  },
  RunListArtifactTypeDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/artifact-types:dynamic-enum-values',
  },
  RunListArtifactTypeKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/artifact-types/kinds',
  },
  RunListArtifactTypes: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifact-types',
  },
  RunListCompactorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/compactors:dynamic-enum-values',
  },
  RunListCompactorKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/compactors/kinds',
  },
  RunListCredentialDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/credentials:dynamic-enum-values',
  },
  RunListCredentialKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/credentials/kinds',
  },
  RunListCredentials: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/credentials',
  },
  RunListCredentialStoreKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/credential-stores/kinds',
  },
  RunListEmbedderDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/embedders:dynamic-enum-values',
  },
  RunListEmbedderKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/embedders/kinds',
  },
  RunListExportFormatKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/export-formats/kinds',
  },
  RunListFollowUpGeneratorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/follow-ups:dynamic-enum-values',
  },
  RunListFollowUpGeneratorKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/follow-ups/kinds',
  },
  RunListGeneratorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/generators:dynamic-enum-values',
  },
  RunListGeneratorKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/generators/kinds',
  },
  RunListImportFormatKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/import-formats/kinds',
  },
  RunListMemoryBlockDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/memory-blocks:dynamic-enum-values',
  },
  RunListMemoryBlockKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/memory-blocks/kinds',
  },
  RunListMemoryBlocks: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/memory-blocks',
  },
  RunListSavedFilters: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/saved-filters/{surface}',
  },
  RunListSchedules: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/schedules',
  },
  RunListSubAgentKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/sub-agents/kinds',
  },
  RunListSubAgents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/sub-agents',
  },
  RunListThreads: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads',
  },
  RunListToolAdapterDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/tool-adapters:dynamic-enum-values',
  },
  RunListToolAdapterKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/tool-adapters/kinds',
  },
  RunListToolAdapters: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  'rain-v1-run_scoped-thread_service.RunListTools': {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/rain.v1.ThreadService/ListTools',
  },
  'rain-v1-run_scoped-tool_catalog_service.RunListTools': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools',
  },
  RunListToolSourceDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/tool-sources:dynamic-enum-values',
  },
  RunListToolSourceKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/tool-sources/kinds',
  },
  RunListToolSources: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tool-sources',
  },
  RunListUtilityGeneratorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/utility-generators:dynamic-enum-values',
  },
  RunListVariables: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/variables',
  },
  RunListVectorCollections: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections',
  },
  RunListVectorStoreDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/vector-stores:dynamic-enum-values',
  },
  RunListVectorStoreKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/vector-stores/kinds',
  },
  RunListVectorStores: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/vector-stores',
  },
  RunMarkStep: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan/active/phases/{phase_index}/steps/{step_index}:mark',
  },
  RunPreviewToolAdapterChain: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters:preview',
  },
  RunPromoteActivePlan: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan:promote',
  },
  RunRehydrateThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}:rehydrate',
  },
  RunRemoveAgentPlanPhase: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}',
  },
  RunRemoveAgentPlanStep: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps/{step_index}',
  },
  RunRemoveAllToolAdapters: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  RunRemoveToolAdapter: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters/{adapter_id}',
  },
  RunReorderAgentPlanPhases: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan/phases:reorder',
  },
  RunReorderAgentPlanSteps: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps:reorder',
  },
  RunReorderToolAdapters: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  RunReplaceMemoryContent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}:replace',
  },
  RunResetConfig: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/agent:reset',
  },
  RunResetEvents: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/events:reset',
  },
  RunResetPlan: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan/active:reset',
  },
  RunRestoreAgentVersion: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/versions/{version}:restore',
  },
  RunRestoreEvent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/events:restore',
  },
  RunRunScheduleNow: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/schedules/{id}:run',
  },
  RunSaveFilter: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/saved-filters/{surface}',
  },
  RunScheduleNow: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/schedules/{id}:run',
  },
  RunSendMessage: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/input',
  },
  RunSendMessageSync: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/events',
  },
  RunSendToolCall: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tool-calls',
  },
  RunSendToolResult: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tool-results',
  },
  RunSetCompactor: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/compactor',
  },
  RunSetEmbedder: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/embedder',
  },
  RunSetEnabledTools: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}:set',
  },
  RunSetFeedback: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/feedback',
  },
  RunSetFollowUpGenerator: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/follow-up',
  },
  RunSetGenerator: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/generator',
  },
  RunSetToolAdapters: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters:set',
  },
  RunSetUtilityGenerator: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/utility-generator',
  },
  RunStartCompaction: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}:compact',
  },
  RunStop: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}:stop',
  },
  RunSubscribeAgentThreadStatus: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/rain.v1.ThreadService/SubscribeAgentThreadStatus',
  },
  RunSubscribeThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/rain.v1.ThreadService/SubscribeThread',
  },
  RunSubscribeThreadStatus: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/rain.v1.ThreadService/SubscribeThreadStatus',
  },
  RunSync: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/connectors/{connector}:runSync',
  },
  RunTagAgentVersion: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/versions/{version}:tag',
  },
  RunTokenize: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/generator/tokenize',
  },
  RunTransfer: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}:transfer',
  },
  RunUntagAgentVersion: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/tags/{tag}',
  },
  RunUpdateAgent: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}',
  },
  RunUpdateAgentPlanPhase: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}',
  },
  RunUpdateAgentPlanStep: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps/{step_index}',
  },
  RunUpdateArtifact: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}',
  },
  RunUpdateArtifactStore: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifact-stores/{store_id}',
  },
  RunUpdateArtifactType: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/artifact-types/{type_id}',
  },
  RunUpdateCredential: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/credentials/{credential_id}',
  },
  RunUpdateMemoryBlock: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}',
  },
  RunUpdateSchedule: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/schedules/{id}',
  },
  RunUpdateSubAgent: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/sub-agents/{sub_agent_id}',
  },
  RunUpdateThread: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}',
  },
  RunUpdateThreadAgentCard: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/card',
  },
  RunUpdateThreadMemory: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/memory/{block_id}',
  },
  RunUpdateTool: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}',
  },
  RunUpdateToolAdapter: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters/{adapter_id}',
  },
  RunUpdateToolSource: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/tool-sources/{source_id}',
  },
  RunUpdateVariable: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/variables/{variable_name}',
  },
  RunUpdateVectorStore: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}',
  },
  RunUpgradeAllThreads: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads:upgradeAll',
  },
  RunUpgradeThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/agent:upgrade',
  },
  RunUploads_StageFile: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}/uploads',
  },
  RunValidateArtifactStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/artifact-stores:validate',
  },
  RunValidateArtifactTypeConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/artifact-types:validate',
  },
  RunValidateCompactorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/compactor:validate',
  },
  RunValidateCredentialConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/credentials:validate',
  },
  RunValidateEmbedderConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/embedder:validate',
  },
  RunValidateFollowUpGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/follow-up:validate',
  },
  RunValidateGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/generator:validate',
  },
  RunValidateMemoryBlockConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/memory-blocks:validate',
  },
  RunValidateToolAdapterConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/tool-adapters:validate',
  },
  RunValidateToolSourceConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/tool-sources:validate',
  },
  RunValidateUtilityGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/utility-generator:validate',
  },
  RunValidateVectorStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/vector-stores:validate',
  },
  RunWake: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent_id}/threads/{thread_id}:wake',
  },
  RunWorkspaceDetectors: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workspaceDetectors:run',
  },
  SaveFilter: {
    method: 'POST',
    path: '/api/v1/saved-filters/{surface}',
  },
  SaveWorkUnitAnswer: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workUnits/{workUnit}:saveAnswer',
  },
  SaveWorkUnitInput: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workUnits/{workUnit}:saveInput',
  },
  SearchBookConcepts: {
    method: 'POST',
    path: '/api/v1/concepts:search',
  },
  SearchBookProcedures: {
    method: 'POST',
    path: '/api/v1/procedures:search',
  },
  SearchBooks: {
    method: 'POST',
    path: '/api/v1/books:search',
  },
  SearchBuiltinFunctions: {
    method: 'POST',
    path: '/jarvis.v1.JarvisService/SearchBuiltinFunctions',
  },
  SearchEntities: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/entities:search',
  },
  SearchResolutions: {
    method: 'POST',
    path: '/astral.v1.TroubleshootingGuideService/SearchResolutions',
  },
  SearchWorkspaceBookConcepts: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/concepts:search',
  },
  SearchWorkspaceBookConnectionProcedures: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}/procedures:search',
  },
  SearchWorkspaceBookProcedures: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/procedures:search',
  },
  SearchWorkspaceBooks: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books:search',
  },
  SeedWorkspaceFromTemplate: {
    method: 'POST',
    path: '/grimoire.v1.AutomationImportExportService/SeedWorkspaceFromTemplate',
  },
  'rain-v1-thread_service.SendMessage': {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/input',
  },
  'zen-v1-thread_service.SendMessage': {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent}/threads/{thread}:sendMessage',
  },
  SendMessageStream: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent}/threads/{thread}:sendMessageStream',
  },
  SendMessageSync: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/events',
  },
  SendNotification: {
    method: 'POST',
    path: '/herald.v1.HeraldService/SendNotification',
  },
  SendToolCall: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tool-calls',
  },
  SendToolResult: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tool-results',
  },
  SetAutomationDefaultInputs: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:setDefaultInputs',
  },
  SetAutomationLabels: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:setLabels',
  },
  SetAutomationsForPollInstance: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/polls/{poll_instance_id}/automations',
  },
  SetAutomationsForTriggerInstance: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/triggers/{trigger_instance_id}/automations',
  },
  SetAutomationsForTriggerInstance2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/triggers/{trigger_instance_id}/automations',
  },
  SetCompactor: {
    method: 'PUT',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/compactor',
  },
  SetDiscovered: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}/discover',
  },
  SetEmbedder: {
    method: 'PUT',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/embedder',
  },
  SetEnabledTools: {
    method: 'PUT',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}:set',
  },
  SetExceptionGroupRouting: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptionGroups:setRouting',
  },
  SetFeedback: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/feedback',
  },
  SetFollowUpGenerator: {
    method: 'PUT',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/follow-up',
  },
  SetGenerator: {
    method: 'PUT',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/generator',
  },
  SetMarkedOutputs: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:setMarkedOutputs',
  },
  SetScoredOutputs: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evals/{evalId}/scoredOutputs',
  },
  SetTestCaseExpectation: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evals/{evalId}/testCases/{testCase}',
  },
  SetTestCaseSplits: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/evals/{evalId}/testCases',
  },
  SetToolAdapters: {
    method: 'PUT',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters:set',
  },
  SetUtilityGenerator: {
    method: 'PUT',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/utility-generator',
  },
  SetWorkItemInputForm: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workItems/{workItem}:setInputForm',
  },
  SkipExceptions: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptions:skip',
  },
  SkipRunStep: {
    method: 'POST',
    path: '/jeeves.v1.RunService/SkipRunStep',
  },
  SkipStep: {
    method: 'POST',
    path: '/astral.v1.ExceptionManagerService/SkipStep',
  },
  StartCompaction: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}:compact',
  },
  Stop: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}:stop',
  },
  StopThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent}/threads/{thread}:stop',
  },
  StoreExceptionReport: {
    method: 'POST',
    path: '/astral.v1.ExceptionManagerService/StoreExceptionReport',
  },
  StoreExceptionResolution: {
    method: 'POST',
    path: '/astral.v1.ExceptionManagerService/StoreExceptionResolution',
  },
  StreamEvents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/agents/{agent}/events:stream',
  },
  StreamRunEvents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/runs/{run}/events:stream',
  },
  StreamThreadMessages: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent}/threads/{thread}/messages:stream',
  },
  StreamUserNotifications: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/notifications/stream',
  },
  StreamUserNotifications2: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/notifications/stream',
  },
  SubscribeAgentThreadStatus: {
    method: 'POST',
    path: '/api/v1/rain.v1.ThreadService/SubscribeAgentThreadStatus',
  },
  SubscribeThread: {
    method: 'POST',
    path: '/api/v1/rain.v1.ThreadService/SubscribeThread',
  },
  SubscribeThreadStatus: {
    method: 'POST',
    path: '/api/v1/rain.v1.ThreadService/SubscribeThreadStatus',
  },
  SwitchAutomationConnections: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:switchConnections',
  },
  TagAgentVersion: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/versions/{version}:tag',
  },
  TestIpsecConnectivity: {
    method: 'POST',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/remoteConnections:testIpsecConnectivity',
  },
  Tokenize: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/generator/tokenize',
  },
  TraceAssetUsage: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/assets/{asset}:traceAssetUsage',
  },
  TraceCollectionUsage: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}:traceCollectionUsage',
  },
  TraceConnectionUsage: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations:traceConnectionUsage',
  },
  Transfer: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}:transfer',
  },
  TransferOrgOwners: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/orgOwners:transfer',
  },
  TransitionFinding: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/findings/{finding}:transition',
  },
  TransitionGuideEntryState: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/guideEntries/{guideEntrie}:transitionState',
  },
  TraverseEntity: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/entities/{entitie}:traverseEntity',
  },
  TuneStepConfig: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/stepConfig',
  },
  UnarchiveExceptions: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/exceptions:unarchive',
  },
  UnarchiveWorkItem: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workItems/{workItem}:unarchive',
  },
  UndeleteAutomation: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:undelete',
  },
  UnsetMarkedOutput: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:unsetMarkedOutput',
  },
  UntagAgentVersion: {
    method: 'DELETE',
    path: '/api/v1/agents/{agent_id}/tags/{tag}',
  },
  UpdateAgent: {
    method: 'PATCH',
    path: '/api/v1/agents/{agent_id}',
  },
  UpdateAgentPlanPhase: {
    method: 'PATCH',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}',
  },
  UpdateAgentPlanStep: {
    method: 'PATCH',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps/{step_index}',
  },
  UpdateArtifact: {
    method: 'PUT',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}',
  },
  UpdateArtifactStore: {
    method: 'PATCH',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifact-stores/{store_id}',
  },
  UpdateArtifactType: {
    method: 'PATCH',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/artifact-types/{type_id}',
  },
  UpdateAsset: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/assets/{asset}',
  },
  UpdateAutomation: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}',
  },
  UpdateAutomationSchedule: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/schedule',
  },
  UpdateBackend: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/backends/{backend}',
  },
  UpdateBackend2: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/backends/{backend}',
  },
  UpdateCockpitTemplate: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/cockpitTemplate',
  },
  UpdateCollection: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}',
  },
  UpdateCollectionField: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}:updateField',
  },
  UpdateCollectionRow: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}/rows/{row}',
  },
  UpdateCollectionRowsByFilter: {
    method: 'POST',
    path: '/bishop.collections.v1.CollectionRowsService/UpdateCollectionRowsByFilter',
  },
  UpdateCollectionSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/collections/{collection}:updateSchema',
  },
  UpdateCredential: {
    method: 'PATCH',
    path: '/api/v1/credentials/{credential_id}',
  },
  UpdateCurrentQuarterGoals: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/currentQuarterGoals',
  },
  UpdateCurrentUser: {
    method: 'PATCH',
    path: '/api/v1/me',
  },
  UpdateCurrentUserWorkspaceNotificationChannelPreferences: {
    method: 'PATCH',
    path: '/api/v1/me/organizations/{organization}/workspaces/{workspace}/notifications/{channel}/preferences',
  },
  UpdateCustomRole: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/customRoles/{customRole}',
  },
  UpdateFolder: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/folders/{folder}',
  },
  UpdateGuide: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/guides/{guide}',
  },
  UpdateGuideEntry: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/guideEntries/{guideEntrie}',
  },
  UpdateMemoryBlock: {
    method: 'PATCH',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}',
  },
  UpdateOAuthApp: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization_id}/oauthApps/{id}',
  },
  UpdateOAuthApp2: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/oauthApps/{id}',
  },
  UpdateOrganization: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}',
  },
  UpdateOrganizationPreferences: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/preferences',
  },
  UpdatePermissionTemplate: {
    method: 'POST',
    path: '/agora.v1.RBACService/UpdatePermissionTemplate',
  },
  UpdatePersonalAccessToken: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/personal_access_tokens/{personal_access_token}',
  },
  UpdateRemoteConnection: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/remoteConnections/{id}',
  },
  UpdateRoleTemplate: {
    method: 'POST',
    path: '/agora.v1.RBACService/UpdateRoleTemplate',
  },
  UpdateSchedule: {
    method: 'PUT',
    path: '/api/v1/agents/{agent_id}/schedules/{id}',
  },
  UpdateSecret: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization_id}/secrets/{id}',
  },
  UpdateSecret2: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/secrets/{id}',
  },
  UpdateSecretType: {
    method: 'PATCH',
    path: '/api/v1/secretTypes/{secretType}',
  },
  UpdateSubAgent: {
    method: 'PATCH',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/sub-agents/{sub_agent_id}',
  },
  'rain-v1-thread_service.UpdateThread': {
    method: 'PATCH',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}',
  },
  'zen-v1-thread_service.UpdateThread': {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}/agents/{agent}/threads/{thread}',
  },
  UpdateThreadAgentCard: {
    method: 'PUT',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/card',
  },
  UpdateThreadMemory: {
    method: 'PATCH',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/memory/{block_id}',
  },
  UpdateTool: {
    method: 'PATCH',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}',
  },
  UpdateToolAdapter: {
    method: 'PATCH',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters/{adapter_id}',
  },
  UpdateToolSource: {
    method: 'PATCH',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/tool-sources/{source_id}',
  },
  UpdateUserPreferences: {
    method: 'PATCH',
    path: '/api/v1/me/preferences',
  },
  UpdateVariable: {
    method: 'PATCH',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/variables/{variable_name}',
  },
  UpdateVectorStore: {
    method: 'PATCH',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}',
  },
  UpdateWorkspace: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}',
  },
  UpdateWorkspaceBookConnection: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books/{book_name}/{book_version}/connections/{connection_id}',
  },
  UpdateWorkspaceBookConnectionAgentTriggerInstance: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}/agent-triggers/{trigger_instance_id}',
  },
  UpdateWorkspaceBookConnectionPollInstance: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}/polls/{poll_instance_id}',
  },
  UpdateWorkspaceBookConnectionTriggerInstance: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/connections/{connection_id}/triggers/{trigger_instance_id}',
  },
  UpdateWorkspaceBookConnectionWithRemoteSecret: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books/{book_name}/{book_version}/connections/{connection_id}/with-remote-secret',
  },
  UpdateWorkspaceNotificationChannelPreferences: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/notifications/{channel}/preferences',
  },
  UpdateWorkspacePreferences: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/preferences',
  },
  UpgradeAllThreads: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads:upgradeAll',
  },
  UpgradeAutomationBookConnectionVersion: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:upgradeBookConnectionVersion',
  },
  UpgradeAutomationConnections: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:upgradeConnections',
  },
  UpgradeThread: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/agent:upgrade',
  },
  UpgradeWorkspaceBookConnection: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books/{book_name}/{book_version}/connections/{connection_id}/upgrade',
  },
  UpgradeWorkspaceBookConnectionWithRemoteSecret: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization_id}/workspaces/{workspace_id}/books/{book_name}/{book_version}/connections/{connection_id}/upgrade-with-remote-secret',
  },
  UploadFile: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/files:upload',
  },
  UploadFile2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/files:upload',
  },
  UploadFileStream: {
    method: 'POST',
    path: '/bishop.files.v1.FilesService/UploadFileStream',
  },
  Uploads_StageFile: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}/uploads',
  },
  UpsertPostAutomationPhase: {
    method: 'POST',
    path: '/grimoire.v1.AutomationPhaseService/UpsertPostAutomationPhase',
  },
  ValidateAgentImport: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agentBundles/{agentBundle}:validateImport',
  },
  ValidateAop: {
    method: 'POST',
    path: '/jarvis.v1.JarvisService/ValidateAop',
  },
  ValidateArtifactStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/artifact-stores:validate',
  },
  ValidateArtifactTypeConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/artifact-types:validate',
  },
  ValidateAutomationImport: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:validateImport',
  },
  ValidateAutomationPublish: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/automations/{automation}:validatePublish',
  },
  ValidateCode: {
    method: 'POST',
    path: '/jarvis.v1.JarvisService/ValidateCode',
  },
  ValidateCompactorConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/compactor:validate',
  },
  ValidateCredentialConfigSchema: {
    method: 'POST',
    path: '/api/v1/credentials:validate',
  },
  ValidateEmbedderConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/embedder:validate',
  },
  ValidateFollowUpGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/follow-up:validate',
  },
  ValidateGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/generator:validate',
  },
  ValidateMemoryBlockConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/memory-blocks:validate',
  },
  ValidatePatch: {
    method: 'POST',
    path: '/jarvis.v1.JarvisService/ValidatePatch',
  },
  ValidateRelease: {
    method: 'POST',
    path: '/v1/organizations/{organization}/workspaces/{workspace}/cartographer:validate',
  },
  ValidateRelease2: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/cartographer:validate',
  },
  ValidateSecretSchema: {
    method: 'POST',
    path: '/api/v1/secretTypes:validateSchema',
  },
  ValidateToolAdapterConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/tool-adapters:validate',
  },
  ValidateToolSourceConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/tool-sources:validate',
  },
  ValidateUtilityGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/utility-generator:validate',
  },
  ValidateVectorStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/vector-stores:validate',
  },
  Wake: {
    method: 'POST',
    path: '/api/v1/agents/{agent_id}/threads/{thread_id}:wake',
  },
  WithdrawWorkUnit: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/workUnits/{workUnit}:withdraw',
  },
  WorkspaceActivatePlan: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan:activate',
  },
  WorkspaceActivateSchedule: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/schedules/{id}:activate',
  },
  WorkspaceAddAgentPlanPhase: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan/phases',
  },
  WorkspaceAddAgentPlanStep: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps',
  },
  WorkspaceAddToolAdapter: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  WorkspaceClearCompactor: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/compactor',
  },
  WorkspaceClearEmbedder: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/embedder',
  },
  WorkspaceClearFollowUpGenerator: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/follow-up',
  },
  WorkspaceClearGenerator: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/generator',
  },
  WorkspaceClearThreadMemory: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/memory/{block_id}',
  },
  WorkspaceClearUtilityGenerator: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/utility-generator',
  },
  WorkspaceCommitArtifacts: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifacts:commit',
  },
  WorkspaceCountTokens: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/generator/tokenize:count',
  },
  WorkspaceCreateAgent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents',
  },
  WorkspaceCreateAgentPlan: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan',
  },
  WorkspaceCreateArtifactStore: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifact-stores',
  },
  WorkspaceCreateArtifactType: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifact-types',
  },
  WorkspaceCreateCredential: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/credentials',
  },
  WorkspaceCreateMemoryBlock: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/memory-blocks',
  },
  WorkspaceCreateSchedule: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/schedules',
  },
  WorkspaceCreateSubAgent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/sub-agents',
  },
  WorkspaceCreateThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads',
  },
  WorkspaceCreateToolSource: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tool-sources',
  },
  WorkspaceCreateVariable: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/variables',
  },
  WorkspaceCreateVectorCollection: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections',
  },
  WorkspaceCreateVectorStore: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/vector-stores',
  },
  WorkspaceDeactivatePlan: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan/active:deactivate',
  },
  WorkspaceDeactivateSchedule: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/schedules/{id}:deactivate',
  },
  WorkspaceDehydrateThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}:dehydrate',
  },
  WorkspaceDeleteAgent: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}',
  },
  WorkspaceDeleteAgentPlan: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan',
  },
  WorkspaceDeleteAllThreads: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads',
  },
  WorkspaceDeleteArtifact: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}',
  },
  WorkspaceDeleteArtifactStore: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifact-stores/{store_id}',
  },
  WorkspaceDeleteArtifactType: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifact-types/{type_id}',
  },
  WorkspaceDeleteCredential: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/credentials/{credential_id}',
  },
  WorkspaceDeleteEvent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/events:delete',
  },
  WorkspaceDeleteMemoryBlock: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}',
  },
  WorkspaceDeleteSavedFilter: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/saved-filters/{surface}/{id}',
  },
  WorkspaceDeleteSchedule: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/schedules/{id}',
  },
  WorkspaceDeleteSubAgent: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/sub-agents/{sub_agent_id}',
  },
  WorkspaceDeleteThread: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}',
  },
  WorkspaceDeleteToolSource: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tool-sources/{source_id}',
  },
  WorkspaceDeleteVariable: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/variables/{variable_name}',
  },
  WorkspaceDeleteVectorCollection: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections/{collection}',
  },
  WorkspaceDeleteVectorStore: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}',
  },
  WorkspaceDeploy: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/agent:deploy',
  },
  WorkspaceDescribeVectorCollection: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections/{collection}',
  },
  WorkspaceDiffAgentPlan: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan:diff',
  },
  WorkspaceDiffArtifacts: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifacts:diff',
  },
  WorkspaceDiffArtifactStores: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifact-stores:diff',
  },
  WorkspaceDiffArtifactTypes: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifact-types:diff',
  },
  WorkspaceDiffCompactor: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/compactor:diff',
  },
  WorkspaceDiffEmbedder: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/embedder:diff',
  },
  WorkspaceDiffFollowUpGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/follow-up:diff',
  },
  WorkspaceDiffGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/generator:diff',
  },
  WorkspaceDiffMemoryBlocks: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/memory-blocks:diff',
  },
  WorkspaceDiffSubAgents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/sub-agents:diff',
  },
  WorkspaceDiffTools: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools:diff',
  },
  WorkspaceDiffToolSources: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tool-sources:diff',
  },
  WorkspaceDiffUtilityGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/utility-generator:diff',
  },
  WorkspaceDiffVariables: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/variables:diff',
  },
  WorkspaceDiffVectorStores: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/vector-stores:diff',
  },
  WorkspaceDisableTool: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}:disable',
  },
  WorkspaceDisableTools: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}:disable',
  },
  WorkspaceDiscardArtifacts: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifacts:discard',
  },
  WorkspaceDuplicateAgent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}:duplicate',
  },
  WorkspaceEmbedAudio: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/embedder:embed-audio',
  },
  WorkspaceEmbedAudioBatch: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/embedder:embed-audio-batch',
  },
  WorkspaceEmbedImage: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/embedder:embed-image',
  },
  WorkspaceEmbedImageBatch: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/embedder:embed-image-batch',
  },
  WorkspaceEmbedText: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/embedder:embed-text',
  },
  WorkspaceEmbedTextBatch: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/embedder:embed-text-batch',
  },
  WorkspaceEmbedVideo: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/embedder:embed-video',
  },
  WorkspaceEmbedVideoBatch: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/embedder:embed-video-batch',
  },
  WorkspaceEnableTool: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}:enable',
  },
  WorkspaceEnableTools: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}:enable',
  },
  WorkspaceExportAgent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}:export',
  },
  WorkspaceForkThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}:fork',
  },
  WorkspaceGenerate: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/rain.v1.GeneratorService/Generate',
  },
  WorkspaceGetActivePlan: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan/active',
  },
  WorkspaceGetAgent: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}',
  },
  WorkspaceGetAgentPlan: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan',
  },
  WorkspaceGetAgentVersion: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/versions/{version}',
  },
  WorkspaceGetAgentVersionByTag: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/tags/{tag}',
  },
  WorkspaceGetArtifact: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}',
  },
  WorkspaceGetArtifactContent: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}:content',
  },
  WorkspaceGetArtifactDiff: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}:diff',
  },
  WorkspaceGetArtifactsStagingSummary: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifacts:staging',
  },
  WorkspaceGetCompactor: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/compactor',
  },
  WorkspaceGetCredential: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/credentials/{credential_id}',
  },
  WorkspaceGetDynamicArtifactStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/artifact-stores:dynamic-config',
  },
  WorkspaceGetDynamicArtifactTypeConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/artifact-types:dynamic-config',
  },
  WorkspaceGetDynamicCompactorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/compactor:dynamic-config',
  },
  WorkspaceGetDynamicCredentialConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/credentials:dynamic-config',
  },
  WorkspaceGetDynamicEmbedderConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/embedder:dynamic-config',
  },
  WorkspaceGetDynamicExportFormatConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/export-formats:dynamic-config',
  },
  WorkspaceGetDynamicFollowUpGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/follow-up:dynamic-config',
  },
  WorkspaceGetDynamicGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/generator:dynamic-config',
  },
  WorkspaceGetDynamicImportFormatConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/import-formats:dynamic-config',
  },
  WorkspaceGetDynamicMemoryBlockConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/memory-blocks:dynamic-config',
  },
  WorkspaceGetDynamicSubAgentConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/sub-agents:dynamic-config',
  },
  WorkspaceGetDynamicToolAdapterConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/tool-adapters:dynamic-config',
  },
  WorkspaceGetDynamicToolSourceConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/tool-sources:dynamic-config',
  },
  WorkspaceGetDynamicUtilityGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/utility-generator:dynamic-config',
  },
  WorkspaceGetDynamicVectorStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/vector-stores:dynamic-config',
  },
  WorkspaceGetEmbedder: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/embedder',
  },
  WorkspaceGetEmbedderInfo: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/embedder-info',
  },
  WorkspaceGetEvents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/events',
  },
  'rain-v1-workspace_scoped-agent_service.WorkspaceGetFilterSchema': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents:filter-schema',
  },
  'rain-v1-workspace_scoped-credential_service.WorkspaceGetFilterSchema': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/credentials:filter-schema',
  },
  'rain-v1-workspace_scoped-schedule_service.WorkspaceGetFilterSchema': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/schedules:filter-schema',
  },
  'rain-v1-workspace_scoped-thread_service.WorkspaceGetFilterSchema': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/threads:filter-schema',
  },
  WorkspaceGetFollowUpGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/follow-up',
  },
  WorkspaceGetGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/generator',
  },
  WorkspaceGetMemoryBlock: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}',
  },
  WorkspaceGetModelInfo: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/generator:model-info',
  },
  WorkspaceGetQueue: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/queue',
  },
  WorkspaceGetSchedule: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/schedules/{id}',
  },
  WorkspaceGetServiceInfo: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/info',
  },
  WorkspaceGetStaticArtifactStoreConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/artifact-stores:static-config',
  },
  WorkspaceGetStaticArtifactTypeConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/artifact-types:static-config',
  },
  WorkspaceGetStaticCompactorConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/compactor:static-config',
  },
  WorkspaceGetStaticCredentialConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/credentials:static-config',
  },
  WorkspaceGetStaticEmbedderConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/embedder:static-config',
  },
  WorkspaceGetStaticExportFormatConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/export-formats:static-config',
  },
  WorkspaceGetStaticFollowUpGeneratorConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/follow-up:static-config',
  },
  WorkspaceGetStaticGeneratorConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/generator:static-config',
  },
  WorkspaceGetStaticImportFormatConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/import-formats:static-config',
  },
  WorkspaceGetStaticMemoryBlockConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/memory-blocks:static-config',
  },
  WorkspaceGetStaticSubAgentConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/sub-agents:static-config',
  },
  WorkspaceGetStaticToolAdapterConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/tool-adapters:static-config',
  },
  WorkspaceGetStaticToolSourceConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/tool-sources:static-config',
  },
  WorkspaceGetStaticUtilityGeneratorConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/utility-generator:static-config',
  },
  WorkspaceGetStaticVectorStoreConfigSchema: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/vector-stores:static-config',
  },
  WorkspaceGetThread: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}',
  },
  WorkspaceGetThreadAgentCard: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/card',
  },
  WorkspaceGetThreadContext: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/context',
  },
  WorkspaceGetThreadCostSummary: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/cost',
  },
  WorkspaceGetThreadCustomizations: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/customizations',
  },
  WorkspaceGetThreadMemory: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/memory',
  },
  WorkspaceGetThreadMemoryBlock: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/memory/{block_id}',
  },
  WorkspaceGetTool: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{tool_id}',
  },
  WorkspaceGetToolAdapter: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters/{adapter_id}',
  },
  WorkspaceGetToolAdapterChain: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters:chain',
  },
  WorkspaceGetUtilityGenerator: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/utility-generator',
  },
  WorkspaceGetUtilityGeneratorModelInfo: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/utility-generator:model-info',
  },
  WorkspaceGrepArtifacts: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifacts:grep',
  },
  WorkspaceImportAgent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents:import',
  },
  WorkspaceInvokeTool: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools:invoke',
  },
  WorkspaceListAgentLabels: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents:labels',
  },
  WorkspaceListAgents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents',
  },
  WorkspaceListAgentVersions: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/versions',
  },
  WorkspaceListAllSchedules: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/schedules',
  },
  WorkspaceListAllThreads: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/threads',
  },
  WorkspaceListArtifacts: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifacts',
  },
  WorkspaceListArtifactStoreDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/artifact-stores:dynamic-enum-values',
  },
  WorkspaceListArtifactStoreKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/artifact-stores/kinds',
  },
  WorkspaceListArtifactStores: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifact-stores',
  },
  WorkspaceListArtifactTypeDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/artifact-types:dynamic-enum-values',
  },
  WorkspaceListArtifactTypeKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/artifact-types/kinds',
  },
  WorkspaceListArtifactTypes: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifact-types',
  },
  WorkspaceListCompactorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/compactors:dynamic-enum-values',
  },
  WorkspaceListCompactorKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/compactors/kinds',
  },
  WorkspaceListCredentialDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/credentials:dynamic-enum-values',
  },
  WorkspaceListCredentialKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/credentials/kinds',
  },
  WorkspaceListCredentials: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/credentials',
  },
  WorkspaceListCredentialStoreKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/credential-stores/kinds',
  },
  WorkspaceListEmbedderDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/embedders:dynamic-enum-values',
  },
  WorkspaceListEmbedderKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/embedders/kinds',
  },
  WorkspaceListExportFormatKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/export-formats/kinds',
  },
  WorkspaceListFollowUpGeneratorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/follow-ups:dynamic-enum-values',
  },
  WorkspaceListFollowUpGeneratorKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/follow-ups/kinds',
  },
  WorkspaceListGeneratorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/generators:dynamic-enum-values',
  },
  WorkspaceListGeneratorKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/generators/kinds',
  },
  WorkspaceListImportFormatKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/import-formats/kinds',
  },
  WorkspaceListMemoryBlockDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/memory-blocks:dynamic-enum-values',
  },
  WorkspaceListMemoryBlockKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/memory-blocks/kinds',
  },
  WorkspaceListMemoryBlocks: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/memory-blocks',
  },
  WorkspaceListSavedFilters: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/saved-filters/{surface}',
  },
  WorkspaceListSchedules: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/schedules',
  },
  WorkspaceListSubAgentKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/sub-agents/kinds',
  },
  WorkspaceListSubAgents: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/sub-agents',
  },
  WorkspaceListThreads: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads',
  },
  WorkspaceListToolAdapterDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/tool-adapters:dynamic-enum-values',
  },
  WorkspaceListToolAdapterKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/tool-adapters/kinds',
  },
  WorkspaceListToolAdapters: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  'rain-v1-workspace_scoped-thread_service.WorkspaceListTools': {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/rain.v1.ThreadService/ListTools',
  },
  'rain-v1-workspace_scoped-tool_catalog_service.WorkspaceListTools': {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools',
  },
  WorkspaceListToolSourceDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/tool-sources:dynamic-enum-values',
  },
  WorkspaceListToolSourceKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/tool-sources/kinds',
  },
  WorkspaceListToolSources: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tool-sources',
  },
  WorkspaceListUtilityGeneratorDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/utility-generators:dynamic-enum-values',
  },
  WorkspaceListVariables: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/variables',
  },
  WorkspaceListVectorCollections: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}/collections',
  },
  WorkspaceListVectorStoreDynamicEnumValues: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/vector-stores:dynamic-enum-values',
  },
  WorkspaceListVectorStoreKinds: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/vector-stores/kinds',
  },
  WorkspaceListVectorStores: {
    method: 'GET',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/vector-stores',
  },
  WorkspaceMarkStep: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan/active/phases/{phase_index}/steps/{step_index}:mark',
  },
  WorkspacePreviewToolAdapterChain: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters:preview',
  },
  WorkspacePromoteActivePlan: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan:promote',
  },
  WorkspaceRehydrateThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}:rehydrate',
  },
  WorkspaceRemoveAgentPlanPhase: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}',
  },
  WorkspaceRemoveAgentPlanStep: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps/{step_index}',
  },
  WorkspaceRemoveAllToolAdapters: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  WorkspaceRemoveToolAdapter: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters/{adapter_id}',
  },
  WorkspaceReorderAgentPlanPhases: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan/phases:reorder',
  },
  WorkspaceReorderAgentPlanSteps: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps:reorder',
  },
  WorkspaceReorderToolAdapters: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters',
  },
  WorkspaceReplaceMemoryContent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}:replace',
  },
  WorkspaceResetConfig: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/agent:reset',
  },
  WorkspaceResetEvents: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/events:reset',
  },
  WorkspaceResetPlan: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan/active:reset',
  },
  WorkspaceRestoreAgentVersion: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/versions/{version}:restore',
  },
  WorkspaceRestoreEvent: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/events:restore',
  },
  WorkspaceRunScheduleNow: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/schedules/{id}:run',
  },
  WorkspaceSaveFilter: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/saved-filters/{surface}',
  },
  WorkspaceSendMessage: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/input',
  },
  WorkspaceSendMessageSync: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/events',
  },
  WorkspaceSendToolCall: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tool-calls',
  },
  WorkspaceSendToolResult: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tool-results',
  },
  WorkspaceSetCompactor: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/compactor',
  },
  WorkspaceSetEmbedder: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/embedder',
  },
  WorkspaceSetEnabledTools: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}:set',
  },
  WorkspaceSetFeedback: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/feedback',
  },
  WorkspaceSetFollowUpGenerator: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/follow-up',
  },
  WorkspaceSetGenerator: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/generator',
  },
  WorkspaceSetToolAdapters: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters:set',
  },
  WorkspaceSetUtilityGenerator: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/utility-generator',
  },
  WorkspaceStartCompaction: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}:compact',
  },
  WorkspaceStop: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}:stop',
  },
  WorkspaceSubscribeAgentThreadStatus: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/rain.v1.ThreadService/SubscribeAgentThreadStatus',
  },
  WorkspaceSubscribeThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/rain.v1.ThreadService/SubscribeThread',
  },
  WorkspaceSubscribeThreadStatus: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/rain.v1.ThreadService/SubscribeThreadStatus',
  },
  WorkspaceTagAgentVersion: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/versions/{version}:tag',
  },
  WorkspaceTokenize: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/generator/tokenize',
  },
  WorkspaceTransfer: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}:transfer',
  },
  WorkspaceUntagAgentVersion: {
    method: 'DELETE',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/tags/{tag}',
  },
  WorkspaceUpdateAgent: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}',
  },
  WorkspaceUpdateAgentPlanPhase: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}',
  },
  WorkspaceUpdateAgentPlanStep: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/plan/phases/{phase_index}/steps/{step_index}',
  },
  WorkspaceUpdateArtifact: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifacts/{artifact_uri}',
  },
  WorkspaceUpdateArtifactStore: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifact-stores/{store_id}',
  },
  WorkspaceUpdateArtifactType: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/artifact-types/{type_id}',
  },
  WorkspaceUpdateCredential: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/credentials/{credential_id}',
  },
  WorkspaceUpdateMemoryBlock: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/memory-blocks/{block_id}',
  },
  WorkspaceUpdateSchedule: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/schedules/{id}',
  },
  WorkspaceUpdateSubAgent: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/sub-agents/{sub_agent_id}',
  },
  WorkspaceUpdateThread: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}',
  },
  WorkspaceUpdateThreadAgentCard: {
    method: 'PUT',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/card',
  },
  WorkspaceUpdateThreadMemory: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/memory/{block_id}',
  },
  WorkspaceUpdateTool: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}',
  },
  WorkspaceUpdateToolAdapter: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tools/{source_id}/{tool_id}/adapters/{adapter_id}',
  },
  WorkspaceUpdateToolSource: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/tool-sources/{source_id}',
  },
  WorkspaceUpdateVariable: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/variables/{variable_name}',
  },
  WorkspaceUpdateVectorStore: {
    method: 'PATCH',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/vector-stores/{store_id}',
  },
  WorkspaceUpgradeAllThreads: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads:upgradeAll',
  },
  WorkspaceUpgradeThread: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/agent:upgrade',
  },
  WorkspaceUploads_StageFile: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}/uploads',
  },
  WorkspaceValidateArtifactStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/artifact-stores:validate',
  },
  WorkspaceValidateArtifactTypeConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/artifact-types:validate',
  },
  WorkspaceValidateCompactorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/compactor:validate',
  },
  WorkspaceValidateCredentialConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/credentials:validate',
  },
  WorkspaceValidateEmbedderConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/embedder:validate',
  },
  WorkspaceValidateFollowUpGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/follow-up:validate',
  },
  WorkspaceValidateGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/generator:validate',
  },
  WorkspaceValidateMemoryBlockConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/memory-blocks:validate',
  },
  WorkspaceValidateToolAdapterConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/tool-adapters:validate',
  },
  WorkspaceValidateToolSourceConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/tool-sources:validate',
  },
  WorkspaceValidateUtilityGeneratorConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/utility-generator:validate',
  },
  WorkspaceValidateVectorStoreConfigSchema: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/vector-stores:validate',
  },
  WorkspaceWake: {
    method: 'POST',
    path: '/api/v1/organizations/{organization}/workspaces/{workspace}/agents/{agent_id}/threads/{thread_id}:wake',
  },
} as const;

export type EndpointKey = keyof typeof ENDPOINTS;
export type HttpMethod = (typeof ENDPOINTS)[EndpointKey]['method'];
